// src/ShiftsPage.js - COMPLETAMENTE DINAMICO

import React, { useState, useEffect, useRef, useMemo } from 'react';
import Holidays from 'date-holidays';
import moment from 'moment';
import 'moment/locale/it';
import { ChangeShiftModal, ConfirmationModal, ChoiceModal } from './Modals';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// 1. Importiamo le funzioni di Firestore che ci servono
import { doc, getDoc, setDoc, collection, onSnapshot, query, where, addDoc, getDocs, orderBy } from "firebase/firestore";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUser } from './UserContext';
import { logAction } from './loggingService';
import { createNotification } from './notificationService';
import { LeaveRequestModal } from './LeaveRequestModal';
import { db, auth, functions } from './firebase'; 
import { httpsCallable } from "firebase/functions";


// Funzioni per Assenze
const processLeaveApproval = httpsCallable(functions, 'processLeaveApproval');
const reverseLeaveAbsence = httpsCallable(functions, 'reverseLeaveAbsence'); 
const cancelLeaveRequest = httpsCallable(functions, 'cancelLeaveRequest');

// 🎯 FIX: Nuova funzione per i Template Ciclici
const applyShiftTemplate = httpsCallable(functions, 'applyShiftTemplate');
moment.locale('it');
const hd = new Holidays('IT');

// Tutti gli stili CSS rimangono invariati
const styles = `
/* ... (TUTTI GLI STILI CSS CHE AVEVAMO PRIMA VANNO QUI, NON LI RIPORTO PER BREVITÀ) ... */
@media print {
    #main-header, #mobile-header, .accordion, nav { display: none !important; }
    body, html { height: 100%; overflow: hidden !important; background: white !important; }
    #main-wrapper { 
        padding: 0 20px !important; /* Aggiunge 20px di margine a destra e sinistra */
        margin: 0 !important; 
    }
    #schedule-container {
        transform: scale(0.55); transform-origin: top left;
        width: 180%; height: 150%; margin: 0; padding: 0;
        page-break-inside: avoid !important;
    }
    th, td {
        font-size: 14pt !important; padding: 4px !important;
        -webkit-print-color-adjust: exact !important; color-adjust: exact !important;
    }
    .shift-details, .nuovo-orario { font-size: 12pt !important; }
    .month-title { font-size: 24pt !important; color: black !important; background: white !important; }
    .pause-info { display: none !important; }
    .straordinario, .permesso-text {
        font-size: 11pt !important; 
        font-weight: bold !important;
    }
    @page { size: A4 portrait; margin: 0; }
}
.export-mode #navigation-controls,
.export-mode .mobile-header-top {
    display: none !important;
}
    .export-mode .pause-info { /* <--- NUOVA REGOLA CRITICA PER LA CATTURA PDF */
    display: none !important;
}
.export-mode #main-header,
.export-mode #mobile-header {
    position: relative !important;
}
    .export-mode #schedule-container {
    margin-top: 80px !important; /* Aggiunge spazio per far posto al riepilogo */
}
body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 10pt; background-color: #f2f2f2; }
#main-wrapper { max-width: 1300px; margin: 0 auto; padding: 0 15px; }
.desktop-only { display: block; }
.mobile-only { display: none; }
#main-header, #mobile-header {
    position: sticky;
     top: 60px;
    z-index: 1001;
     padding-top: 10px;
    background: transparent;
}
#navigation-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 8px;
    padding: 8px 15px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.08);
}
.nav-left, .nav-right { display: flex; flex-direction: row; align-items: center; gap: 10px; }
.action-buttons { display: flex; flex-direction: row; gap: 8px; }
#month-tabs { display: flex; gap: 5px; flex-grow: 1; justify-content: center; }
#month-tabs button {
    padding: 8px 12px;
    border: none;
    background-color: #4a90e2;
    color: white;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
}
#month-tabs button.active { background-color: #d0021b; }
.action-buttons button, .logout-button {
    background-color: transparent;
    border: none;
    width: 32px; 
    height: 32px;
    border-radius: 4px;
    font-size: 1rem;
    display: flex; 
    align-items: center; 
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;
}
    .action-buttons button:hover, .logout-button:hover {
    background-color: #d0021b; 
}
.logout-button {  }
.accordion {
    margin-top: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid rgba(0,0,0,0.1);
    box-shadow: 0 4px 15px rgba(0,0,0,0.08);
}
.accordion-toggle {
    background-color: #f8f9fa; color: #4a90e2; cursor: pointer;
    padding: 12px 15px; width: 100%; border: none; text-align: left;
    font-size: 11pt; font-weight: 500;
}
.accordion-toggle.open { background-color: #0d6efd; color: white; }
.accordion-content { padding: 0; max-height: 0; overflow: hidden; transition: max-height 0.3s ease-out; background-color: white; }
.accordion-content.open { max-height: 500px; transition: max-height 0.4s ease-in; padding: 15px; }
.month-title { font-size: 14pt; font-weight: bold; text-align: center; padding: 10px; background-color: #4a90e2; color: white; margin-top: 20px; }
table { border-collapse: collapse; width: 100%; margin-bottom: 25px; border: 2px solid #000; table-layout: fixed; }
th, td { border: 1px solid #999; padding: 4px; text-align: center; vertical-align: middle; font-size: 11pt; height: 60px; overflow: hidden; word-wrap: break-word; font-weight: bold; }
th.week-day-header { background-color:rgb(55, 103, 157); font-weight: bold; color: white; }
td.person-name { font-weight: bold; width: 100px; border-right: px solid #000; }

td.festivo, td.chiuso { background-color: #ffcdd2 !important; font-weight: bold; color: #b71c1c; }
td.ferie { background-color: #fff9c4 !important; font-weight: bold; }
td.malattia { background-color: #e0e0e0 !important; font-weight: bold; }
td.permesso { background-color: #e1bee7 !important; }
td.changeable-shift { cursor: pointer; }
td.changeable-shift:hover { outline: 2px solid #333; outline-offset: -2px; }
.shift-details, .nuovo-orario { font-size: 9pt; color: #333; font-weight: normal; }
.recupero { background-color: #e69138; color: black !important; font-style: italic; padding: 2px 4px; border-radius: 3px; }
.straordinario, .permesso-text { font-weight: bold; color: #b71c1c; }
.summary-table { font-size: 10pt; margin-top: 0; border: 1px solid #ccc; }
.summary-table th { background-color: #f2f2f2; }
.summary-table td { padding: 4px; }
.summary-overtime { color: #38761d; font-weight: bold; }
.summary-leave { color: #cc0000; font-weight: bold; }
.summary-table th,
    .summary-table td {
        padding: 8px 2px;
        font-size: 15pt;
        white-space: nowrap;
        vertical-align: middle;
    }
    .summary-table th {
        font-size: 0 !important;
        color: transparent;
    }
    .summary-table th::before {
        font-size: 12pt !important;
        color: #333;
        font-weight: bold;
    }
    .summary-table th:nth-child(1)::before { content: 'Personale'; }
    .summary-table th:nth-child(2)::before { content: 'Ore Ordinarie'; }
    .summary-table th:nth-child(3)::before { content: 'Straordinario'; }
    .summary-table th:nth-child(4)::before { content: 'Permesso'; }
    .summary-table th:nth-child(5)::before { content: 'Ferie'; }
    .summary-table th:nth-child(6)::before { content: 'Malattia'; }
@media (max-width: 768px) {
    .pause-info {
        display: none !important;
    }
    .desktop-only { display: none !important; }
    .mobile-only { display: block !important; }
    #mobile-header .controls-container, #mobile-header .accordion { border-radius: 8px; }
    .mobile-header-top { 
        display: flex; justify-content: space-between; align-items: center; 
        padding: 8px;
        background-color: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        border: 1px solid rgba(0,0,0,0.1);
        border-radius: 8px;
        box-shadow: 0 4px 15px rgba(0,0,0,0.08);
    }
    .mobile-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
    }
    .mobile-actions button,
    .logout-button {
      background: none;
      border: none;
      padding: 5px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .hamburger-btn, .mobile-actions button { background: none; border: none; cursor: pointer; font-size: 1.6rem; padding: 5px; color: #212529; }
    .mobile-menu-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.6); z-index: 2000; }
    .mobile-menu { position: fixed; top: 0; left: 0; width: 80%; max-width: 300px; height: 100%; background-color: #fff; box-shadow: 4px 0 15px rgba(0,0,0,0.2); display: flex; flex-direction: column; }
    .mobile-menu-header { display: flex; justify-content: space-between; align-items: center; padding: 15px; }
    .mobile-menu-header h3 { margin: 0; font-size: 1.1rem; }
    .close-menu-btn { background: none; border: none; font-size: 1.2rem; cursor: pointer; }
    .mobile-menu-content { padding: 15px; overflow-y: auto; text-align: left; }
    .mobile-menu-content h4 { margin-top: 15px; margin-bottom: 10px; color: #555; border-bottom: 1px solid #ddd; padding-bottom: 5px; }
    .mobile-menu-content h4:first-child { margin-top: 0; }
    .mobile-year-selector { padding: 5px; }

    .summary-table th,
    .summary-table td {
        padding: 8px 2px;
        font-size: 5pt;
        white-space: nowrap;
        vertical-align: middle;
    }
    .summary-table th::before {
        font-size: 4pt !important;
        color: #333;
        font-weight: bold;
    }

    .print-export-buttons.mobile {
      display: flex;
      flex-direction: row;
      gap: 10px;
      justify-content: center;
    }
    .print-export-buttons.mobile button {
      background: none;
      border: none;
      padding: 0;
      width: 100%;
      font-size: 0;
    }
    .print-export-buttons.mobile button img {
      width: 25px;
      height: 25px;
    }
    .year-export-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 20px;
    }
    .year-export-row .mobile-year-selector select {
      font-size: 1rem;
      padding: 6px 8px;
      border-radius: 6px;
      border: 1px solid #ccc;
      background-color: #fff;
    }
    .year-export-row .print-export-buttons.mobile {
      display: flex;
      flex-direction: row;
      gap: 20px;
      justify-content: flex-end;
    }
    .year-export-row .print-export-buttons.mobile button {
      background: none;
      border: none;
      padding: 0;
      width: auto;
    }
    .year-export-row .print-export-buttons.mobile button img {
      width: 25px;
      height: 25px;
    }
    .mobile-months-list { display: flex; flex-direction: column; gap: 8px; }
    .mobile-months-list button { width: 100%; padding: 12px; border: none; border-radius: 8px; text-align: left; font-size: 1rem; color: white; background-color: #4a90e2; }
    .mobile-months-list button.active { background-color: #d0021b; }
    th, td {
        font-size: 5pt;
        font-weight: bold;
        height: auto;
        min-height: 55px;
        padding: 3px 2px;
    }
    td.person-name {
        width: 75px;
        font-size: 6pt;
        font-weight: bold;
        white-space: normal;
        line-height: 1.2;
        vertical-align: middle;
    }
    .shift-details, .recupero, .straordinario, .permesso-text, .nuovo-orario {
        font-size: 4pt;
    }
    .month-title {
        font-size: 13pt;
        margin-top: 10px;
    }
    .modal { align-items: flex-start; padding-top: 10vh; }
    .modal-content { padding: 15px; width: 95%; }
    .modal-content h3 { font-size: 1.1rem; margin-top: 0; }
    .modal-content p { font-size: 0.9rem; }
    .modal-button { padding: 8px 16px; }
}
    
    .success-toast {
      width: 60px !important;
      height: 60px !important;
      border-radius: 50% !important;
      background-color: #4caf50 !important;
      color: white !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      font-size: 2rem !important;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
      text-align: center !important;
      margin-top: 10px !important;
      position: relative !important;
    }
    .success-toast::before {
      content: "✔";
      position: absolute;
      font-size: 2rem;
      color: white;
    }
    @media (max-width: 768px) {
      .Toastify__toast-container--top-center {
        top: 20px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
      }
    }
      .export-mode .accordion-content {
        transition: none !important;
    }
    #schedule-container { margin-top: 40px; }
    table[id^="week-"] { scroll-margin-top: 200px; }
    
    .pending-leave-request {
    font-size: 8pt;
    font-weight: bold;
    color: #b71c1c; /* Rosso scuro */
    margin-top: 4px;
}
`;

// 2. RIMUOVIAMO COMPLETAMENTE `ALL_STAFF` e `SHIFT_TIMES`
const START_DATE = moment('2025-10-01');
const END_DATE = moment('2050-12-31');
const isHoliday = (momentDate) => !!hd.isHoliday(momentDate.toDate());

// Calcola il colore del testo (nero o bianco) in base alla luminosità dello sfondo
const getContrastColor = (hexColor) => {
    if (!hexColor) return '#000000';
    const hex = hexColor.replace('#', '');
    if (hex.length !== 6) return '#000000';
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // Formula luminosità percepita (standard WCAG)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
};


// 4. CREIAMO UN NUOVO COMPONENTE `ShiftCell` DINAMICO
const ShiftCell = React.memo(({ personData, day, schedule, onCellClick, canChangeShift, pendingRequests }) => {
    const dayStr = day.format('YYYY-MM-DD');
   const shiftData = schedule[dayStr]?.[personData.id] || schedule[dayStr]?.[personData.name];
    const pendingRequest = pendingRequests.find(req => req.userId === personData.id && day.isBetween(req.startDate, req.endDate, 'day', '[]'));
    let content = '';
    
    // 2. AGGIUNGIAMO O RIMUOVIAMO LA CLASSE PER IL CURSORE IN BASE AI PERMESSI
    let className = canChangeShift ? 'changeable-shift' : '';

    // Funzione per calcolare l'orario della pausa
    const getPauseString = (pauseStartTime, pauseMinutes) => {
        if (!pauseMinutes || pauseMinutes <= 0 || !pauseStartTime) return '';
        const pauseStartMoment = moment(pauseStartTime, 'HH:mm');
        const pauseEndMoment = pauseStartMoment.clone().add(pauseMinutes, 'minutes');
        return `(P:${pauseStartMoment.format('HH:mm')}-${pauseEndMoment.format('HH:mm')})`;
    };

    if (shiftData?.name === 'CHIUSO') {
        className = 'chiuso';
        content = 'CHIUSO';
    } else if (isHoliday(day)) {
        className = 'festivo';
        content = 'FESTIVO';
    } else if (shiftData) {
        let baseShiftName = shiftData.originalName || shiftData.name;
        if (shiftData.isRecovery) {
            baseShiftName = baseShiftName.replace(/ REC$/, '').trim() + ' REC';
        }
        
        const dayStr = day.format('YYYY-MM-DD');
        const timeSlot = personData.timeSlots.find(ts => {
            const from = ts.validFrom || "2020-01-01";
            const until = ts.validUntil || "2100-01-01";
            return ts.name === baseShiftName && moment(dayStr).isBetween(from, until, 'day', '[]');
        });

        // 🎯 FIX CHIRURGICO: Calcolo se il permesso copre tutto il turno
        let isFullDayLeave = false;
        if (shiftData.leave && (shiftData.leave.h > 0 || shiftData.leave.m > 0)) {
            const leaveMinutesTotal = (shiftData.leave.h * 60) + (shiftData.leave.m || 0);
            let shiftMinutesTotal = 0;

            if (timeSlot) {
                const startM = moment(timeSlot.startTime, 'HH:mm');
                const endM = moment(timeSlot.endTime, 'HH:mm');
                shiftMinutesTotal = endM.diff(startM, 'minutes');
                if (timeSlot.pauseMinutes) shiftMinutesTotal -= parseInt(timeSlot.pauseMinutes);
            } else if (shiftData.name === 'Nuovo Orario' && shiftData.customTime) {
                const startM = moment(shiftData.customTime.start, 'HH:mm');
                const endM = moment(shiftData.customTime.end, 'HH:mm');
                shiftMinutesTotal = endM.diff(startM, 'minutes');
                // 🆕 Sottrai la pausa opzionale, se impostata
                if (shiftData.customTime.pauseMinutes) shiftMinutesTotal -= parseInt(shiftData.customTime.pauseMinutes);
            }

            // Se i minuti di permesso coprono (o superano) i minuti lavorativi
            if (shiftMinutesTotal > 0 && leaveMinutesTotal >= shiftMinutesTotal) {
                isFullDayLeave = true;
            }
        }

        // --- RENDERIZZAZIONE DELLA CELLA ---
        if (shiftData.name === 'Ferie' || shiftData.name === 'Malattia') {
            content = shiftData.name.toUpperCase();
            className = shiftData.name.toLowerCase(); 
        } 
        else if (shiftData.name === 'Maternità') {
            content = 'MATERNITÀ';
            className = 'maternita';
        }
        else if (isFullDayLeave) {
            // 🎯 SE È PERMESSO TOTALE: Nascondi il turno e mostra solo il permesso
            content = `PERMESSO<br><span class="shift-details" style="font-weight:bold">${String(shiftData.leave.h).padStart(2, '0')}:${String(shiftData.leave.m).padStart(2, '0')} h</span>`;
            className = 'permesso';
        }
        else if (shiftData.name === 'Nuovo Orario' && shiftData.customTime) {
            // 🆕 Mostra la pausa (in minuti) solo se è stata impostata, stessa dimensione
            // dell'orario (riusa la classe "nuovo-orario", niente grassetto/stile a parte)
            const pauseLabel = shiftData.customTime.pauseMinutes
                ? ` <span class="nuovo-orario">(P ${shiftData.customTime.pauseMinutes}m)</span>`
                : '';
            content = `Nuovo Orario<br><span class="nuovo-orario">${shiftData.customTime.start} - ${shiftData.customTime.end}</span>${pauseLabel}`;
        }
        else {
            // RENDER STANDARD (Turno normale + permessi parziali / str. / rec.)
            if (timeSlot) {
                let displayName = timeSlot.name.replace(/ REC$/, '');
                if (displayName === 'standard' || displayName === 'recupero') {
                    displayName = 'Ufficio';
                }
                const pauseString = getPauseString(timeSlot.pauseStartTime, timeSlot.pauseMinutes);
                const recoveryClass = timeSlot.isRecovery ? 'recupero' : '';
                const recoveryText = timeSlot.isRecovery ? '(Rec.)' : '';
                content = `${displayName}<br><span class="shift-details ${recoveryClass}">${timeSlot.startTime}-${timeSlot.endTime}${recoveryText} <span class="pause-info">${pauseString}</span></span>`;
            } else {
                content = baseShiftName;
            }
        }

        // Aggiungi le label testuali extra SOLO se non è un permesso totale
        if (!isFullDayLeave) {
            if (shiftData.leave?.h > 0 || shiftData.leave?.m > 0) {
                content += `<br><span class="permesso-text">- Perm. ${String(shiftData.leave.h).padStart(2, '0')}:${String(shiftData.leave.m).padStart(2, '0')}</span>`;
                className += ' permesso'; // Aggiunge colore viola misto
            }
            if (shiftData.overtime?.h > 0 || shiftData.overtime?.m > 0) {
                content += `<br><span class="straordinario">+ Str. ${String(shiftData.overtime.h).padStart(2, '0')}:${String(shiftData.overtime.m).padStart(2, '0')}</span>`;
            }
            if (shiftData.recovery?.h > 0 || shiftData.recovery?.m > 0) {
                content += `<br><span class="summary-leave">- Rec. ${String(shiftData.recovery.h).padStart(2, '0')}:${String(shiftData.recovery.m).padStart(2, '0')}</span>`;
            }
        }

        // Classi finali di styling
        if (shiftData.name?.includes('Sabato')) className += ` sabato-turno`;
    }

    if (pendingRequest) {
        content += `<div class="pending-leave-request">Richiesta ${pendingRequest.type} in approvazione</div>`;
    }
    
    if (day.isoWeekday() === 6) {
        className += ' sabato';
    }
    
    let bgColor = personData.color;
    // Annulla il colore di sfondo utente se la cella deve prendere il colore dell'assenza
    if (shiftData?.name === 'CHIUSO' || isHoliday(day) || shiftData?.name === 'Ferie' || shiftData?.name === 'Malattia' || shiftData?.name === 'Maternità' || shiftData?.name === 'Permesso' || className.includes('permesso')) {
        bgColor = ''; 
    }
    else if (day.isoWeekday() === 6 && !shiftData) {
        bgColor = '#ffffff';
    }
    
    const textColor = bgColor ? getContrastColor(bgColor) : undefined;
const contentWithColor = textColor && bgColor
    ? content
        .replace(/class="shift-details/g, `style="color:${textColor};opacity:0.85;" class="shift-details`)
        .replace(/class="nuovo-orario/g, `style="color:${textColor};opacity:0.85;" class="nuovo-orario`)
        .replace(/class="pause-info/g, `style="color:${textColor};opacity:0.75;" class="pause-info`)
    : content;

return <td
    className={className}
    style={{backgroundColor: bgColor, color: textColor}}
    onClick={() => canChangeShift && !isHoliday(day) && onCellClick(shiftData)}
    dangerouslySetInnerHTML={{ __html: contentWithColor }}
/>;
});

function ShiftsPage({ handleLogout }) {
    const { userProfile } = useUser(); // 4. OTTENIAMO IL PROFILO UTENTE
    const leavesPermissionLevel = userProfile?.permissions?.leaves || 'none';
    // 5. DEFINIAMO I LIVELLI DI PERMESSO PER QUESTA PAGINA
    const permissionLevel = userProfile?.permissions?.shifts || 'none';
    const canEditAll = permissionLevel === 'completo' || permissionLevel === 'semi-completo';
    const canEditSelf = permissionLevel === 'self-edit';
    const canCloseDays = permissionLevel === 'completo';
    
    const [staffData, setStaffData] = useState([]);
    const [scheduleData, setScheduleData] = useState({ fullSchedule: {}, saturdayAssignments: {} });
    const [selectedYear, setSelectedYear] = useState(moment().year());
    const [selectedMonth, setSelectedMonth] = useState(moment().month());
    const [history, setHistory] = useState([]);
    const [historyIndex, setHistoryIndex] = useState(-1);
    const [modal, setModal] = useState({ type: null, data: null });
    const [monthlyStats, setMonthlyStats] = useState(null);
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const [initialSchedule, setInitialSchedule] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const hasScrolledRef = useRef(false);

    const [isLeaveModalOpen, setIsLeaveModalOpen] = useState(false);
    const [leaveModalData, setLeaveModalData] = useState(null);
    const [pendingRequests, setPendingRequests] = useState([]);
    const isProcessingUndoRedo = useRef(false);
    const lastLocalOperationIdRef = useRef(null); // Traccia l'ID dell'ultima op. LOCALE

    const [isGenerating, setIsGenerating] = useState(false);
    const [isLoadingSchedule, setIsLoadingSchedule] = useState(false);
    const [baseShifts, setBaseShifts] = useState(['Mattina', 'Pomeriggio', 'Chiusura']);

    const [activeTab, setActiveTab] = useState('rotation');

    // 🎯 FIX: Stati per il nuovo Modale Template
    const [availableTemplates, setAvailableTemplates] = useState([]);

   console.log('Rendering ShiftsPage - historyIndex:', historyIndex, 'history length:', history.length); // Monitora lo stato

   const filteredStaffData = useMemo(() => {
    // DEBUG: Vediamo tutto lo staffData
    console.log(`[DEBUG] staffData completo:`, staffData.map(p => ({id: p.id, name: p.name, assignmentType: p.assignmentType})));
    
    const result = staffData.filter(person => {
        if (activeTab === 'rotation') {
            return person.assignmentType !== 'backoffice';
        } else {
            return person.assignmentType === 'backoffice';
        }
    });
    console.log(`[DEBUG] activeTab: ${activeTab}, filteredStaffData:`, result.map(p => ({id: p.id, name: p.name, assignmentType: p.assignmentType})));
    return result;
}, [staffData, activeTab]);

// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
        let unsubscribeSchedule = () => {};
        let unsubscribeRequests = () => {};
        let unsubscribeShiftConfig = () => {};

        const loadAndListen = async () => {
            const user = auth.currentUser;
            // Aggiungi controllo per isLoading per evitare esecuzioni multiple all'avvio
            if (!user || !userProfile || !userProfile.centerId) return; // <-- MODIFICA QUI
        const centerId = userProfile.centerId; // Variabile locale per pulizia

            console.log(`>>> loadAndListen avviato per ${selectedYear}-${selectedMonth + 1}`);

            // --- Caricamento staff e saturdayAssignments ---
            const staffCollectionRef = collection(db, 'centers', centerId, 'staff'); // <-- MODIFICA QUI
        const staffSnapshot = await getDocs(staffCollectionRef);
            const allStaff = staffSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            const schedulableStaff = allStaff
    .filter(person => {
        // Gli utenti backoffice sono sempre inclusi, gli altri seguono includeInShifts
        if (person.assignmentType === 'backoffice') {
            return true;
        }
        return person.includeInShifts !== false;
    })
    .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));

            if (schedulableStaff.length === 0) {
                console.warn("Nessun personale trovato per la turnazione. Reset stato.");
                setStaffData([]);
                setScheduleData({ fullSchedule: {}, saturdayAssignments: {} });
                setHistory([]);
                setHistoryIndex(-1);
                //isLoading(false); // Imposta isLoading a false qui se necessario
                return; // Interrompe
            }
            setStaffData(schedulableStaff); // Imposta solo se c'è personale

            const satDocRef = doc(db, 'centers', centerId, "rotation", "saturdays"); // <-- MODIFICA QUI
            const satDocSnap = await getDoc(satDocRef);
            let saturdayAssignments;
            if (satDocSnap.exists()) {
                saturdayAssignments = satDocSnap.data().assignments;
            } else {
    console.log("Saturday assignments non trovati. Verranno generati dalla Cloud Function.");
    saturdayAssignments = {}; // Inizializza vuoto
}
            // --- Fine Caricamento ---
            // --- NUOVO: Carica e ascolta i turni base ---
            console.log("Impostazione listener onSnapshot per shiftConfig");
            const shiftConfigDocRef = doc(db, 'centers', centerId, "settings", "shiftConfig"); // <-- MODIFICA QUI
            unsubscribeShiftConfig = onSnapshot(shiftConfigDocRef, (docSnap) => {
                if (docSnap.exists() && docSnap.data().mandatoryShifts) {
                    const loadedShifts = docSnap.data().mandatoryShifts;
                    console.log("Turni base caricati:", loadedShifts);
                    setBaseShifts(loadedShifts);
                    // NOTA: Non è necessario ricalcolare lo schedule qui.
                    // Il ricalcolo avviene solo se lo schedule del mese non esiste.
                    // Se i turni base cambiano, influenzeranno i *nuovi* mesi generati.
                } else {
                    console.warn("Documento shiftConfig non trovato, uso default.");
                    // Lo stato 'baseShifts' mantiene già il default
                }
            }, (error) => {
                 console.error("Errore ascolto shiftConfig:", error);
            });
            const monthDocId = `${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}`;
            const monthDocRef = doc(db, 'centers', centerId, "schedules", monthDocId); // <-- MODIFICA QUI

            // Listener per il documento del mese
            console.log(`Impostazione listener onSnapshot per ${monthDocId}`);
            unsubscribeSchedule = onSnapshot(monthDocRef, (docSnap) => {
                console.log(`--- onSnapshot TRIGGERATO --- ${monthDocId}, Esiste: ${docSnap.exists()}`);
                let monthlySchedule = {};
                const remoteData = docSnap.data(); // Leggi i dati una sola volta
                const remoteLastOpId = remoteData?.lastOpId; // Leggi l'ID operazione remota

                // --- INIZIO BLOCCO MODIFICATO ---
                if (docSnap.exists() && remoteData?.schedule) {
                    // CASO 1: Lo schedule esiste, lo leggo
                    try {
                        monthlySchedule = JSON.parse(remoteData.schedule);
                    } catch (e) { console.error("Errore parsing schedule JSON:", e); }
                } else if (schedulableStaff.length > 0) {
                    // CASO 2: Lo schedule NON esiste.
                    // NON facciamo nulla in automatico. Aspettiamo il click sul pulsante.
                    console.log(`Documento ${monthDocId} non trovato. Attendere generazione manuale.`);
                }
                // --- FINE BLOCCO MODIFICATO ---

                const newFirebaseData = { fullSchedule: monthlySchedule, saturdayAssignments };

                // --- Logica Sincronizzazione RIVISTA con Controllo REF ---
                console.log(`-> onSnapshot Check: isProcessing=${isProcessingUndoRedo.current}, remoteOpId=${remoteLastOpId}, lastLocalOpIdRef=${lastLocalOperationIdRef.current}`);

                // IGNORA se siamo in Undo/Redo OPPURE se l'ID remoto CORRISPONDE all'ID dell'ultima operazione LOCALE salvato nel REF
                if (isProcessingUndoRedo.current || (remoteLastOpId && remoteLastOpId === lastLocalOperationIdRef.current)) {
                    if (isProcessingUndoRedo.current) {
                        console.log("%c-> onSnapshot IGNORATO: Undo/Redo in corso.", "color: orange;");
                    } else {
                        console.log(`%c-> onSnapshot IGNORATO: Eco dell'operazione locale ${lastLocalOperationIdRef.current}.`, "color: blue;");
                    }
                } else {
                    // Non è un eco dell'ultima op locale e non siamo in Undo/Redo.
                    // Confrontiamo i DATI per vedere se è un cambio esterno o il primo caricamento.
                    const currentLocalSchedule = history[historyIndex]?.schedule?.fullSchedule;
                    const firebaseScheduleString = JSON.stringify(newFirebaseData.fullSchedule);
                    const localScheduleString = JSON.stringify(currentLocalSchedule);

                    // Sincronizza solo se è il primo caricamento O se i dati sono effettivamente diversi
                    const needsSync = historyIndex === -1 || firebaseScheduleString !== localScheduleString;

                    if (needsSync) {
                        console.warn(`%c-> onSnapshot: SINCRONIZZAZIONE necessaria (historyIndex=${historyIndex}, dati diversi=${firebaseScheduleString !== localScheduleString}). Reset history e UI.`, "color: red; font-weight: bold;");
                        const initialState = {
                            schedule: JSON.parse(JSON.stringify(newFirebaseData)),
                            metadata: { remoteOpId: remoteLastOpId } // Salva l'ID remoto per riferimento
                        };
                        setHistory([initialState]);
                        setHistoryIndex(0);
                        setScheduleData(initialState.schedule); // Aggiorna UI
                        setInitialSchedule(JSON.parse(firebaseScheduleString)); // Aggiorna base per reset
                        // Aggiorna il ref con l'ID remoto appena SINCRONIZZATO
                        // Questo è cruciale per evitare loop se un altro utente salva lo stesso stato
                        lastLocalOperationIdRef.current = remoteLastOpId;
                        console.log(`   (Aggiornato lastLocalOperationIdRef a ${remoteLastOpId} dopo sync)`);
                    } else {
                        console.log("-> onSnapshot: Dati Firebase CORRISPONDONO allo stato locale corrente. Nessuna azione UI/History.");
                        // I dati sono uguali, ma l'ID remoto potrebbe essere diverso se un altro utente ha salvato
                        // uno stato identico. Aggiorniamo il ref per riflettere l'ultimo ID visto sul DB.
                        if (remoteLastOpId && remoteLastOpId !== lastLocalOperationIdRef.current) {
                             lastLocalOperationIdRef.current = remoteLastOpId;
                             console.log(`   (Aggiornato lastLocalOperationIdRef a ${remoteLastOpId} anche se dati uguali)`);
                        }
                    }
                }
                // --- Fine Logica Sincronizzazione ---

            }, (error) => {
                console.error(`Errore nell'ascolto di ${monthDocId}:`, error);
                // Qui potresti voler mostrare un errore all'utente
                // setIsLoading(false); // Assicurati che il caricamento finisca anche in caso di errore
            });

            // --- Ascolto Richieste Pendenti (con orderBy) ---
            console.log("Impostazione listener richieste pendenti...");
            const requestsRef = collection(db, 'centers', centerId, 'leaveRequests'); // <-- MODIFICA QUI
            const canViewAllLeaves = userProfile.permissions?.leaves === 'completo' || userProfile.permissions?.leaves === 'semi-completo';
            const q = canViewAllLeaves
                ? query(requestsRef, where('status', '==', 'pending'), orderBy('startDate', 'asc'))
                : query(requestsRef, where('status', '==', 'pending'), where('userId', '==', userProfile?.uid), orderBy('startDate', 'asc'));
            unsubscribeRequests = onSnapshot(q, (snapshot) => {
                setPendingRequests(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            }, (error) => {
                 console.error("Errore ascolto richieste pendenti:", error);
            });
            // --- Fine Ascolto Richieste ---
        }; // Fine loadAndListen

        // Reset stati prima di avviare il caricamento del nuovo mese
        console.log(`>>> CAMBIO MESE/ANNO o CARICAMENTO INIZIALE - Reset stati per ${selectedYear}-${selectedMonth + 1}`);
        setHistory([]);
        setHistoryIndex(-1);
        lastLocalOperationIdRef.current = null; // Resetta anche l'ultimo ID locale
        setScheduleData({ fullSchedule: {}, saturdayAssignments: {} }); // Pulisce UI
        setInitialSchedule(null); // Pulisce schedule iniziale
        // setIsLoading(true); // Se vuoi mostrare un caricamento
        loadAndListen(); // Avvia caricamento e listener

        // Funzione di pulizia
        return () => {
            console.log(">>> Pulizia listeners useEffect <<<");
            unsubscribeSchedule();
            unsubscribeRequests();
            
        };
    // Rimuovi staffData dalle dipendenze, altrimenti causa loop se lo stato staff cambia
    }, [selectedYear, selectedMonth, userProfile]);

    // 🎯 FIX: Apre il modale per scegliere il Template
    const handleOpenTemplateModal = async () => {
        setIsGenerating(true);
        try {
            // Carica i template disponibili per il tab corrente
            const collectionName = activeTab === 'backoffice' ? 'backofficeTemplates' : 'shiftTemplates';
            const templatesRef = collection(db, 'centers', userProfile.centerId, collectionName);
            const snap = await getDocs(templatesRef);
            const loaded = snap.docs
                .map(d => ({ id: d.id, ...d.data() }))
                .filter(t => t.roleType === activeTab || !t.roleType);
            
            setAvailableTemplates(loaded);
            
            // Pre-imposta le date sul mese che l'utente sta guardando
            const startOfSelectedMonth = moment({ year: selectedYear, month: selectedMonth }).startOf('month').format('YYYY-MM-DD');
            const endOfSelectedMonth = moment({ year: selectedYear, month: selectedMonth }).endOf('month').format('YYYY-MM-DD');

            setModal({
                type: 'apply-template',
                data: {
                    templateId: '',
                    startDate: startOfSelectedMonth,
                    endDate: endOfSelectedMonth
                }
            });
        } catch (err) {
            console.error(err);
            toast.error("Errore caricamento modelli.");
        } finally {
            setIsGenerating(false);
        }
    };

    // 🎯 FIX: Invia la richiesta alla Cloud Function
    const handleApplyTemplateConfirm = async () => {
        const { templateId, startDate, endDate } = modal.data;
        if (!templateId || !startDate || !endDate) {
            toast.warning("Seleziona un modello e un range di date valido.");
            return;
        }

        closeModal();
        setIsGenerating(true);
        const toastId = toast.loading("Srotolamento del modello sul calendario in corso...");

        try {
            const targetStaffIds = filteredStaffData.map(s => s.id);
            
            const result = await applyShiftTemplate({
                centerId: userProfile.centerId,
                templateId: templateId,
                startDate: startDate,
                endDate: endDate,
                roleType: activeTab,
                targetStaffIds: targetStaffIds,
                mode: modal.data.mode // <--- Passiamo la modalità!
            });

            if (result.data.success) {
                toast.update(toastId, { render: "Calendario generato con successo!", type: "success", isLoading: false, autoClose: 3000 });
                await logAction(userProfile, `ha applicato un modello di turnazione dal ${moment(startDate).format('DD/MM/YY')} al ${moment(endDate).format('DD/MM/YY')}`);
            } else {
                throw new Error("Errore sconosciuto dal motore.");
            }
        } catch (error) {
            console.error("Errore applyShiftTemplate:", error);
            toast.update(toastId, { render: `Errore: ${error.message}`, type: "error", isLoading: false, autoClose: 5000 });
        } finally {
            setIsGenerating(false);
            // La pagina si aggiornerà automaticamente grazie al listener onSnapshot!
        }
    };

   // ⭐ --- INIZIO BLOCCO PER SINCRONIZZAZIONE AUTOMATICA --- ⭐
useEffect(() => {
    const handleVisibilityChange = async () => {
        if (document.visibilityState === 'visible') {
            const monthDocId = `${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}`;
            const monthDocRef = doc(db, 'centers', userProfile.centerId, 'schedules', monthDocId);
            
            try {
                const docSnap = await getDoc(monthDocRef);
                if (docSnap.exists() && docSnap.data() && docSnap.data().schedule) {
                    const serverSchedule = JSON.parse(docSnap.data().schedule);
                    setScheduleData(prev => ({ ...prev, fullSchedule: serverSchedule }));
                } 
                // RIMUOVI O COMMENTA L'ELSE CHE CANCELLAVA TUTTO
                // else {
                //    setScheduleData(prev => ({ ...prev, fullSchedule: {} })); 
                // }
            } catch (error) {
                console.warn("Impossibile aggiornare i turni al ritorno sulla pagina:", error);
                // Non fare nulla, mantieni i dati che hai già!
            }
        }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
}, [selectedYear, selectedMonth, userProfile.centerId]);
// --- FINE BLOCCO ---
    
    // ... (Tutte le altre funzioni come useEffect per lo scroll, le statistiche, etc. rimangono invariate)
    useEffect(() => {
        if (!hasScrolledRef.current && scheduleData.fullSchedule && Object.keys(scheduleData.fullSchedule).length > 0) {
            const currentWeekStart = moment().startOf('isoWeek').format('YYYY-MM-DD');
            const currentWeekId = `week-${currentWeekStart}`;
            
            const currentWeekElement = document.getElementById(currentWeekId);
            
            if (currentWeekElement) {
                currentWeekElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                hasScrolledRef.current = true;
            }
        }
    }, [scheduleData.fullSchedule, history, historyIndex]);

    useEffect(() => {
        hasScrolledRef.current = false;
    }, [selectedMonth, selectedYear]);
       
    useEffect(() => {
        if (!scheduleData.fullSchedule || Object.keys(scheduleData.fullSchedule).length === 0 || staffData.length === 0) return;
        
        const stats = {};
        staffData.forEach(person => {
            stats[person.id] = {
                Mattina: 0, Pomeriggio: 0, Chiusura: 0, NuovoOrario: 0, Ufficio: 0, Ferie: 0, Malattia: 0,
                OvertimeMinutes: 0, LeaveMinutes: 0,
                OrdinaryMinutes: 0, // 🆕 Monte ore ordinarie del mese (turno previsto, MAI lo straordinario, MENO permessi/malattia/ferie)
            };
        });

        // 🆕 Calcola i minuti PREVISTI di un turno per quella persona/giorno, guardando
        // la stessa fascia oraria (timeSlots) usata per disegnare la cella del calendario.
        // Ferie/Malattia/CHIUSO non hanno una fascia oraria associata: restituiscono 0
        // automaticamente (nessun timeSlot combacia con quel nome), quindi quei giorni
        // non contribuiscono da soli al monte ore — esattamente come "sottrarre le ore
        // che avrebbe dovuto lavorare", senza bisogno di stimarle a parte.
        const getShiftExpectedMinutes = (personData, dayMoment, shiftData) => {
            if (!shiftData) return 0;
            let baseShiftName = shiftData.originalName || shiftData.name;
            if (shiftData.isRecovery) {
                baseShiftName = baseShiftName.replace(/ REC$/, '').trim() + ' REC';
            }
            const dayStr = dayMoment.format('YYYY-MM-DD');
            const timeSlot = (personData.timeSlots || []).find(ts => {
                const from = ts.validFrom || "2020-01-01";
                const until = ts.validUntil || "2100-01-01";
                return ts.name === baseShiftName && moment(dayStr).isBetween(from, until, 'day', '[]');
            });
            if (timeSlot) {
                const startM = moment(timeSlot.startTime, 'HH:mm');
                const endM = moment(timeSlot.endTime, 'HH:mm');
                let mins = endM.diff(startM, 'minutes');
                if (timeSlot.pauseMinutes) mins -= parseInt(timeSlot.pauseMinutes);
                return Math.max(0, mins);
            }
            if (shiftData.name === 'Nuovo Orario' && shiftData.customTime) {
                const startM = moment(shiftData.customTime.start, 'HH:mm');
                const endM = moment(shiftData.customTime.end, 'HH:mm');
                let mins = endM.diff(startM, 'minutes');
                // 🆕 Sottrai la pausa opzionale, se impostata
                if (shiftData.customTime.pauseMinutes) mins -= parseInt(shiftData.customTime.pauseMinutes);
                return Math.max(0, mins);
            }
            return 0;
        };
    
        const monthStart = moment([selectedYear, selectedMonth, 1]);
        const monthEnd = monthStart.clone().endOf('month');
    
        for (let day = monthStart.clone(); day.isSameOrBefore(monthEnd); day.add(1, 'day')) {
            const dayStr = day.format('YYYY-MM-DD');
            if (scheduleData.fullSchedule[dayStr]) {
                staffData.forEach(person => {
                    const shiftData = scheduleData.fullSchedule[dayStr][person.id] || scheduleData.fullSchedule[dayStr][person.name];
                    if (!shiftData) return;
    
                    const shiftName = shiftData.name;
    
                    if (stats[person.id] && (shiftName === 'Mattina' || shiftName === 'Pomeriggio' || shiftName === 'Chiusura')) {
                        stats[person.id][shiftName]++;
                    }
                    if (shiftName === 'Nuovo Orario') stats[person.id].NuovoOrario++;
                    if (shiftName === 'standard') stats[person.id].Ufficio++;
                    if (shiftName === 'Ferie') stats[person.id].Ferie++;
                    if (shiftName === 'Malattia') stats[person.id].Malattia++;
    
                    if (shiftData.overtime) {
                        stats[person.id].OvertimeMinutes += (shiftData.overtime.h * 60) + (shiftData.overtime.m || 0);
                    }
                    if (shiftData.leave) {
                        stats[person.id].LeaveMinutes += (shiftData.leave.h * 60) + (shiftData.leave.m || 0);
                    }

                    // 🆕 Ore ordinarie: turno previsto per quel giorno (MAI lo straordinario,
                    // che vive solo in shiftData.overtime e qui non viene mai sommato) meno
                    // le ore di permesso di quel giorno stesso.
                    const expectedMinutes = getShiftExpectedMinutes(person, day, shiftData);
                    const leaveMinutesThatDay = shiftData.leave ? (shiftData.leave.h * 60) + (shiftData.leave.m || 0) : 0;
                    stats[person.id].OrdinaryMinutes += Math.max(0, expectedMinutes - leaveMinutesThatDay);
                });
            }
        }
        setMonthlyStats(stats);
    }, [scheduleData, selectedMonth, selectedYear, staffData]);

    const saveScheduleToFirebase = async (dataToSave, showToast = true, operationId = null) => {
        const user = auth.currentUser;
        if (!user) {
            console.error("Salvataggio bloccato: utente non autenticato.");
            throw new Error("Utente non autenticato."); // Lancia errore per bloccare Undo/Redo
        }

        const centerId = userProfile.centerId;

        const { fullSchedule, saturdayAssignments } = dataToSave;

        // Prepara lo schedule specifico per il mese corrente
        const scheduleForMonth = {};
        const currentMonthMoment = moment({ year: selectedYear, month: selectedMonth });
        for (const dayStr in fullSchedule) {
            if (moment(dayStr).isSame(currentMonthMoment, 'month')) {
                scheduleForMonth[dayStr] = fullSchedule[dayStr];
            }
        }

        const shouldSaveMonthSchedule = Object.keys(scheduleForMonth).length > 0;

        // Prepara i dati per Firestore
        const monthDocId = `${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}`;
        const monthDocRef = doc(db, 'centers', centerId, 'schedules', monthDocId); // <-- CORREZIONE CHIAVE
        const dataToSet = {};

        if (shouldSaveMonthSchedule) {
            dataToSet.schedule = JSON.stringify(scheduleForMonth);
        }
        // Aggiungi l'ID operazione se fornito
        if (operationId !== null) {
            dataToSet.lastOpId = operationId;
        }

        try {
            // Salva schedule mensile e/o ID operazione
            // Usa setDoc con merge:true per creare il documento se non esiste o aggiornarlo
            if (shouldSaveMonthSchedule || operationId !== null) {
                 console.log(`Salvataggio su ${monthDocId}, Op ID: ${operationId}`, dataToSet);
                 await setDoc(monthDocRef, dataToSet, { merge: true });
            } else {
                 console.log(`Nessun dato schedule da salvare per ${monthDocId}`);
                 // Se non salviamo lo schedule, potremmo voler salvare solo l'opId?
                 // Dipende se vuoi tracciare anche operazioni che non modificano lo schedule del mese.
                 // Per ora, lo salviamo solo se c'è anche lo schedule o se l'ID è esplicitamente passato.
            }

            // Salva saturdayAssignments separatamente (solo se presente)
            if (saturdayAssignments) {
                const satDocRef = doc(db, 'centers', userProfile.centerId, "rotation", "saturdays"); // <-- MODIFICA QUI
                console.log("Salvataggio Saturday Assignments...");
                await setDoc(satDocRef, { assignments: saturdayAssignments });
            }

            // Toast di successo
            if (showToast) {
            toast.success("", {
                position: window.innerWidth <= 768 ? "top-center" : "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                className: 'success-toast',
                icon: false,
            });
        }
    } catch (error) {
        console.error("Errore durante il salvataggio su Firebase:", error);
        if (showToast) {
            toast.error("❌ Errore durante il salvataggio.");
        }
        // Propaga l'errore per gestirlo nelle funzioni chiamanti (Undo/Redo)
        throw error;
    }
};

    const updateSchedule = async (newScheduleData, metadata = {}) => {
        const user = auth.currentUser;
        if (!user) return;

        // Genera un ID univoco per questa specifica operazione
        const operationId = Date.now(); // Usiamo un timestamp come ID semplice

        // --- AGGIORNA IL REF SINCRONAMENTE ---
        lastLocalOperationIdRef.current = operationId; // Aggiorna SUBITO il ref
        console.log(`>>> updateSchedule: Op ID ${operationId}. Aggiornato lastLocalOperationIdRef.`);

        // Prepara il nuovo stato da aggiungere alla cronologia
        const newState = {
            schedule: JSON.parse(JSON.stringify(newScheduleData)), // Clona profondamente lo stato
            metadata: {
                ...metadata, // Mantieni metadati esistenti (es. createdLeaveRequestId)
                operationId: operationId // Aggiungi l'ID univoco dell'operazione
            }
        };

        // Aggiorna la cronologia locale
        const newHistory = history.slice(0, historyIndex + 1);
        newHistory.push(newState);
        const newIndex = newHistory.length - 1;

        console.log(`>>> updateSchedule: Nuovo historyIndex sarà: ${newIndex}`); // Log aggiunto

        // Aggiorna gli stati React (questi sono asincroni)
        setHistory(newHistory);
        setHistoryIndex(newIndex);
        setScheduleData(newState.schedule); // Aggiorna lo stato visualizzato

        try {
            // Salva su Firebase, passando anche l'ID dell'operazione
            await saveScheduleToFirebase(newScheduleData, true, operationId);
            // await logAction(userProfile, `...`); // Aggiungi log specifico se necessario
        } catch (error) {
             console.error("Errore durante il salvataggio in updateSchedule:", error);
             // Considera se vuoi annullare l'aggiornamento locale in caso di errore di salvataggio
             toast.error("Salvataggio fallito.");
             // Potresti voler ripristinare lo stato precedente qui:
             // setHistoryIndex(historyIndex);
             // if (history[historyIndex]) { // Controlla se esiste
             //    setScheduleData(history[historyIndex].schedule);
             // }
        }
    };
    

    {/*const handleForceRecalculate = async () => {
        if (window.confirm("Sei sicuro di voler rigenerare la turnazione? Tutte le modifiche non salvate andranno perse.")) {
            const pristineSchedule = calculateScheduleData(START_DATE, END_DATE, staffData, null);
            updateSchedule(pristineSchedule);
            
            const scheduleForMonth = {};
            const monthMoment = moment({ year: selectedYear, month: selectedMonth });
            for (const dayStr in pristineSchedule.fullSchedule) {
                if (moment(dayStr).isSame(monthMoment, 'month')) {
                    scheduleForMonth[dayStr] = pristineSchedule.fullSchedule[dayStr];
                }
            }
            setInitialSchedule(JSON.parse(JSON.stringify(scheduleForMonth)));
            alert("Turnazione rigenerata con successo!");
        }
    };*/}

    const closeModal = () => setModal({ type: null, data: null });

    const handleHeaderClick = (dayStr) => {
        // 6. BLOCCHIAMO L'AZIONE SE L'UTENTE NON PUÒ CHIUDERE I GIORNI
        if (!canCloseDays) return;

        if(staffData.length === 0) return;

// Logica di controllo chiusura robusta (Nome + ID)
let isDayClosed = false;
const dayData = scheduleData.fullSchedule[dayStr];
if (dayData) {
    const firstPerson = staffData[0];
    // Controlla prima per ID, poi per Nome (vecchi dati)
    const shiftData = dayData[firstPerson.id] || dayData[firstPerson.name];
    isDayClosed = shiftData?.name === 'CHIUSO';
}

setModal({ type: isDayClosed ? 'reopen-day' : 'close-day', data: { dayStr }});
    };
    
    const handleDayManagement = async (isClosing) => {
        const { dayStr } = modal.data;
        const newSchedule = JSON.parse(JSON.stringify(scheduleData));
        //const ALL_STAFF_NAMES = staffData.map(s => s.name);

        if (isClosing) {
    const day = moment(dayStr);
    
    // ✅ FIX: Se è un sabato, rimuovi i recuperi per chi lavorava quel sabato
    if (day.isoWeekday() === 6) {
        // Trova chi lavorava il sabato (sia per ID che per Nome)
        let originalWorkerProfile = null;
        
        for (const p of staffData) {
            const shift = newSchedule.fullSchedule[dayStr]?.[p.id] || 
                         newSchedule.fullSchedule[dayStr]?.[p.name];
            
            if (shift?.name === 'Sabato') {
                originalWorkerProfile = p;
                break;
            }
        }
        
        if (originalWorkerProfile) {
            console.log(`🔍 Trovato lavoratore sabato: ${originalWorkerProfile.name}`);
            
            const weekStart = day.clone().startOf('isoWeek');
            
            // Rimuovi i recuperi Mar-Ven per questa persona
            for (let i = 1; i < 5; i++) {
                const d = weekStart.clone().add(i, 'days').format('YYYY-MM-DD');
                const dayData = newSchedule.fullSchedule[d];
                if (!dayData) continue;
                
                const personShift = dayData[originalWorkerProfile.id] || 
                                   dayData[originalWorkerProfile.name];
                
                if (personShift && !isHoliday(moment(d))) {
                   // Segretaria: Togli flag isRecovery
                    if (originalWorkerProfile.role === 'Segretaria') {
                        personShift.isRecovery = false;
                        
                        // ✅ FIX: Pulisci anche il nome
                        const baseName = (personShift.originalName || personShift.name).replace(' REC', '').trim();
                        personShift.name = baseName;
                        personShift.originalName = baseName;
                    }
                    // Altri ruoli: Trova fascia NON-REC
                    else {
                        const currentBaseName = (personShift.originalName || personShift.name)
                            .replace(' REC', '').trim();
                        
                        const normalSlot = originalWorkerProfile.timeSlots.find(ts => 
                            !ts.isRecovery && 
                            ts.name === currentBaseName &&
                            moment(d).isBetween(
                                ts.validFrom || "2020-01-01", 
                                ts.validUntil || "2100-01-01", 
                                'day', '[]'
                            )
                        );
                        
                        if (normalSlot) {
                            personShift.name = normalSlot.name;
                            personShift.isRecovery = false;
                            personShift.originalName = normalSlot.name;
                        } else {
                            // Fallback
                            personShift.name = currentBaseName;
                            personShift.isRecovery = false;
                            personShift.originalName = currentBaseName;
                        }
                    }
                    
                    // Salva su ID
                    delete dayData[originalWorkerProfile.name];
                    dayData[originalWorkerProfile.id] = personShift;
                    
                    console.log(`✅ Rimosso REC per ${originalWorkerProfile.name} il ${d}`);
                }
            }
        }
    }
    
    // 🌟 FIX: Imposta CHIUSO per tutti e memorizza il turno precedente
            staffData.forEach(person => {
                if (!newSchedule.fullSchedule[dayStr]) newSchedule.fullSchedule[dayStr] = {};
                
                // Catturiamo il turno corrente prima di schiacciarlo
                const currentShift = newSchedule.fullSchedule[dayStr][person.id] || newSchedule.fullSchedule[dayStr][person.name];
                
                newSchedule.fullSchedule[dayStr][person.id] = { 
                    name: 'CHIUSO',
                    previousShift: currentShift // <-- Il nostro cassetto segreto per il ripristino
                };
                
                // Puliamo per sicurezza eventuali refusi sul vecchio formato (nome)
                delete newSchedule.fullSchedule[dayStr][person.name];
            });
            
        } else {
            // 🌟 FIX: Riapertura che pesca i turni dal cassetto segreto
            const migratedDayData = {};

            staffData.forEach(person => {
                // Prendi l'oggetto "CHIUSO" attuale
                const currentClosedShift = newSchedule.fullSchedule[dayStr]?.[person.id] || newSchedule.fullSchedule[dayStr]?.[person.name];

                // Se l'oggetto ha salvato il turno precedente, usiamo quello
                if (currentClosedShift && currentClosedShift.name === 'CHIUSO' && currentClosedShift.previousShift && Object.keys(currentClosedShift.previousShift).length > 0) {
                    migratedDayData[person.id] = currentClosedShift.previousShift;
                } else {
                    // Fallback di sicurezza: se per qualche motivo mancasse (es. chiusure fatte prima di questo fix), 
                    // prova la vecchia strada ignorando però i turni rimasti "CHIUSO"
                    const originalDayData = initialSchedule ? (initialSchedule[dayStr] || {}) : {};
                    const originalShift = originalDayData[person.id] || originalDayData[person.name];
                    
                    if (originalShift && originalShift.name !== 'CHIUSO') {
                        migratedDayData[person.id] = originalShift;
                    }
                }
            });

            // Se la giornata non è completamente vuota assegniamola, altrimenti la eliminiamo in modo pulito
            if (Object.keys(migratedDayData).length > 0) {
                newSchedule.fullSchedule[dayStr] = migratedDayData;
            } else {
                delete newSchedule.fullSchedule[dayStr];
            }
        }
        
        const actionText = isClosing ? "ha chiuso" : "ha riaperto";
        await logAction(userProfile, `${actionText} il giorno ${moment(dayStr).format('DD/MM/YYYY')}`);
                
        updateSchedule(newSchedule);
        closeModal();
    };

    const handleSaturdayManualChange = async (person, dayStr, action) => {
    // Questa funzione ora PREPARA solo i dati per 'handleRecalculate'
    const newSchedule = JSON.parse(JSON.stringify(scheduleData));
    const weekStart = moment(dayStr).startOf('isoWeek');
    const saturdayStr = weekStart.clone().add(5, 'days').format('YYYY-MM-DD');
    
    // Identifica i profili in base al NOME (come fa il modale)
    const newWorkerProfile = staffData.find(s => s.name === person); // Persona che stiamo AGGIUNGENDO/RIMUOVENDO
    if (!newWorkerProfile) {
         console.error("Profilo nuovo lavoratore non trovato:", person);
         return;
    }

    // ✅ LOGICA ROBUSTA PER TROVARE IL LAVORATORE ORIGINALE
    // Cerca tra tutto lo staff chi ha il turno 'Sabato' in quel giorno,
    // escludendo il 'newWorker' (nel caso in cui stiamo rimuovendo).
    let originalWorkerProfile = null;
    if (newSchedule.fullSchedule[saturdayStr]) {
        for (const p of staffData) {
            // Se stiamo aggiungendo, non può essere lo stesso.
            // Se stiamo rimuovendo, questo troverà la persona stessa, il che è irrilevante.
            if (p.id === newWorkerProfile.id) continue; 
            
            // Controlla sia per ID (nuovo standard) che per Nome (vecchio standard)
            const shift = newSchedule.fullSchedule[saturdayStr][p.id] || newSchedule.fullSchedule[saturdayStr][p.name];
            
            if (shift?.name === 'Sabato') {
                originalWorkerProfile = p; // Trovato! (es. Claudia)
                break;
            }
        }
    }

    // Funzione helper per AGGIORNARE i REC (usa ID)
    const updateRecs = (profile, addRec) => {
    if (!profile) return;

    for (let i = 1; i < 5; i++) { // Mar-Ven
        const d = weekStart.clone().add(i, 'days').format('YYYY-MM-DD');
        const dayData = newSchedule.fullSchedule[d];
        if (!dayData) continue;

        // Cerca il turno sia per ID che per Nome (per sicurezza)
        const personShift = dayData[profile.id] || dayData[profile.name];

        // Applica la logica solo se c'è un turno e non è festivo/assenza
        if (personShift && !isHoliday(moment(d)) && 
            personShift.name !== 'CHIUSO' && 
            personShift.name !== 'Ferie' && 
            personShift.name !== 'Malattia') {

            // Logica Segretaria (flag 'isRecovery')
            if (profile.role === 'Segretaria') {
    personShift.isRecovery = addRec;
    
    // Pulisci o aggiungi " REC" dal nome per coerenza
    const baseName = (personShift.originalName || personShift.name).replace(' REC', '').trim();
    if (addRec) {
        personShift.name = `${baseName} REC`;
    } else {
        personShift.name = baseName;
    }
    personShift.originalName = personShift.name;
}
            // Logica Altri Ruoli (cambio nome fascia oraria)
            else {
                // Trova il nome base del turno (es. "Mattina" da "Mattina REC")
                const currentBaseName = (personShift.originalName || personShift.name)
                    .replace(' REC', '').trim();
                let targetSlot = null;

                if (addRec) {
                    // Cerco il turno REC corrispondente VALIDO OGGI
                    targetSlot = profile.timeSlots.find(ts => 
                        ts.isRecovery && 
                        ts.name.includes(currentBaseName) &&
                        moment(d).isBetween(
                            ts.validFrom || "2020-01-01", 
                            ts.validUntil || "2100-01-01", 
                            'day', '[]'
                        )
                    );
                } else {
                    // ✅ FIX CRITICO: Cerco il turno NON-REC corrispondente VALIDO OGGI
                    targetSlot = profile.timeSlots.find(ts => 
                        !ts.isRecovery && 
                        ts.name === currentBaseName &&
                        moment(d).isBetween(
                            ts.validFrom || "2020-01-01", 
                            ts.validUntil || "2100-01-01", 
                            'day', '[]'
                        )
                    );
                }

                if (targetSlot) {
                    // Applica il nome e lo stato REC trovati
                    personShift.name = targetSlot.name;
                    personShift.isRecovery = targetSlot.isRecovery;
                    personShift.originalName = targetSlot.name;
                    
                    console.log(`✅ ${addRec ? 'Aggiunto' : 'Rimosso'} REC per ${profile.name} il ${d}: ${personShift.name}`);
                } else {
                    console.warn(`⚠️ Nessuna fascia oraria trovata per ${addRec ? 'Aggiungi' : 'Togli'} REC su base ${currentBaseName} valida il ${d}`);
                    
                    if (!addRec) {
                        // ✅ FALLBACK: Se sto togliendo e non trovo, forzo la rimozione
                        personShift.name = currentBaseName;
                        personShift.isRecovery = false;
                        personShift.originalName = currentBaseName;
                        console.log(`🔧 Fallback: Forzata rimozione REC per ${profile.name} il ${d}`);
                    }
                }
            }

            // Salva sempre sull'ID e pulisci il vecchio nome
            delete dayData[profile.name]; 
            dayData[profile.id] = personShift; 
        }
    }
};

    if (action === 'AGGIUNGI_SABATO') {
        // 1. Rimuovi il vecchio lavoratore (se c'era)
        if (originalWorkerProfile) {
            delete newSchedule.fullSchedule[saturdayStr][originalWorkerProfile.id];
            delete newSchedule.fullSchedule[saturdayStr][originalWorkerProfile.name]; // Pulizia
            updateRecs(originalWorkerProfile, false); // Togli REC al vecchio
        }

        // 2. Aggiungi il nuovo lavoratore (su ID)
        if (!newSchedule.fullSchedule[saturdayStr]) newSchedule.fullSchedule[saturdayStr] = {};
        newSchedule.fullSchedule[saturdayStr][newWorkerProfile.id] = { name: 'Sabato' };
        updateRecs(newWorkerProfile, true); // Aggiungi REC al nuovo

    } else if (action === 'RIMUOVI_SABATO') {
        // Rimuovi il lavoratore (sia ID che Nome)
        if (newSchedule.fullSchedule[saturdayStr]) {
            delete newSchedule.fullSchedule[saturdayStr][newWorkerProfile.id];
            delete newSchedule.fullSchedule[saturdayStr][newWorkerProfile.name]; // Pulizia
        }
        updateRecs(newWorkerProfile, false); // Togli REC
    }

    // ✅ FIX: Salva direttamente lo schedule modificato senza chiedere il ricalcolo
    await updateSchedule(newSchedule);
    toast.success("Modifica applicata con successo.");
    closeModal();
};

    const allShiftOptions = useMemo(() => {
        // Se non ci sono dati staff, ritorna solo le opzioni standard
        if (!staffData || staffData.length === 0) {
           return [
               // Opzioni fisse sempre disponibili
               { value: "RICHIESTA_ASSENZA", label: "📋 Richiesta Assenza" },
               { value: "Straordinario", label: "Straordinario" },
               { value: "Nuovo Orario", label: "Nuovo Orario" },
               { value: "AGGIUNGI_SABATO", label: "Scambio Sabato"},
               { value: "RIMUOVI_SABATO", label: "Togli Sabato (con recupero)"},
               { value: "AggiungiRecuperoPersonalizzato", label: "Aggiungi Recupero Personalizzato" },
               { value: "TogliRecupero", label: "Togli Recupero" },
           ].sort((a, b) => a.label.localeCompare(b.label)); // Ordina
        }

        const uniqueSlots = new Map();
        staffData.forEach(staff => {
            console.log(`Staff: ${staff.name}, timeSlots:`, staff.timeSlots);
            (staff.timeSlots || []).forEach(slot => {
                console.log(`  - Turno: ${slot.name}, excludeFromChangeShift: ${slot.excludeFromChangeShift} (tipo: ${typeof slot.excludeFromChangeShift})`);
                // 🔥 FILTRA I TURNI CON excludeFromChangeShift = true (controllo esplicito)
                if (slot.excludeFromChangeShift === true) {
                    console.log(`    ⛔ Turno "${slot.name}" ESCLUSO da cambio turno`);
                    return; // Salta questo turno
                }
                
                console.log(`    ✅ Turno "${slot.name}" INCLUSO nel cambio turno`);
                // Usa slot.name come valore univoco
                // Mappa "standard" a "Ufficio" per la visualizzazione
                const label = (slot.name === 'standard') ? 'Ufficio' : slot.name;
                // Aggiungi solo se non già presente (basato sul nome originale)
                if (!uniqueSlots.has(slot.name)) {
                   uniqueSlots.set(slot.name, { value: slot.name, label: label });
                }
            });
        });

         // Opzioni fisse sempre disponibili (assenze, azioni, ecc.)
         const standardOptions = [
            { value: "CANCELLA_TURNO", label: "🗑️ CANCELLA TURNO (Svuota cella)" },
             { value: "RICHIESTA_ASSENZA", label: "📋 Richiesta Assenza" },
             { value: "Straordinario", label: "Straordinario" },
             { value: "Nuovo Orario", label: "Nuovo Orario" },
             // Azioni speciali Sabato/Recupero
             { value: "AGGIUNGI_SABATO", label: "Scambio Sabato"},
             { value: "RIMUOVI_SABATO", label: "Togli Sabato (con recupero)"},
             { value: "AggiungiRecuperoPersonalizzato", label: "Aggiungi Recupero Personalizzato" },
             { value: "TogliRecupero", label: "Togli Recupero" },
         ];

         // Combina le fasce orarie uniche con le opzioni standard
         const combined = [...uniqueSlots.values(), ...standardOptions];

         // Rimuovi eventuali duplicati se una fascia oraria ha lo stesso nome di un'opzione standard
         // (es. se qualcuno crea una fascia chiamata "Ferie")
         const finalOptions = Array.from(new Map(combined.map(item => [item.value, item])).values());

         // Ordina alfabeticamente per nome visualizzato (label)
         finalOptions.sort((a, b) => a.label.localeCompare(b.label));

         console.log("Opzioni Turno Generate (esclusi turni nascosti):", finalOptions); // Log per debug
         return finalOptions; // Ritorna l'array di oggetti { value: string, label: string }

    }, [staffData]); // Ricalcola solo quando staffData cambia
    // --- FINE NUOVO BLOCCO ---


const handleShiftChange = async (data) => {
    const { personId, personName, dayStr, newShiftName, overtime, leave, customTime, recovery } = data;
    const personProfile = staffData.find(p => p.id === personId); // ✅ USA ID
    if (!personProfile) {
        console.error("Profilo persona non trovato per:", personName);
        return;
    }

    const leavesPermissionLevel = userProfile?.permissions?.leaves || 'none';
    const isLeaveRequestType = newShiftName === 'RICHIESTA_ASSENZA';

    // --- Gestione Cancellazione Permesso (0 ore) ---
    const originalShift = data.shiftData; // ✅ USA I DATI PASSATI DAL MODALE
    const isCancelingPermission = originalShift?.leave && (originalShift.leave.h > 0 || originalShift.leave.m > 0) && newShiftName === 'Permesso' && leave && leave.h === 0 && leave.m === 0;

    if (isCancelingPermission) {
        // Logica per cancellare il permesso con 0 ore (questa parte funziona, la lasciamo invariata)
         const q = query(collection(db, 'centers', userProfile.centerId, "leaveRequests"), // <-- MODIFICA QUI
            where("userId", "==", personProfile.id),
            where("startDate", "<=", dayStr),
            where("endDate", ">=", dayStr),
            where("type", "in", ["Permesso retribuito (ROL)", "Permesso non retribuito"])
        );
        const querySnapshot = await getDocs(q);
        const requestIdToDelete = !querySnapshot.empty ? querySnapshot.docs[0].id : null;

        if (requestIdToDelete) {
            try {
                await toast.promise(
                cancelLeaveRequest({ requestId: requestIdToDelete, centerId: userProfile.centerId }), // <-- MODIFICA QUI
                    { /* opzioni toast */ }
                );
                // Forza refresh (invariato)
                closeModal();
                // ... (logica refresh stato locale da firestore) ...
                 const monthDocId = `${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}`;
                const monthDocRef = doc(db, "schedules", monthDocId);
                const docSnap = await getDoc(monthDocRef);
                if (docSnap.exists() && docSnap.data().schedule) {
                     const serverSchedule = JSON.parse(docSnap.data().schedule);
                     setScheduleData(prev => ({ ...prev, fullSchedule: serverSchedule }));
                     const currentStateAfterCancel = { schedule: JSON.parse(JSON.stringify({ ...scheduleData, fullSchedule: serverSchedule })), metadata: {} };
                     const newHistory = history.slice(0, historyIndex + 1);
                     newHistory.push(currentStateAfterCancel);
                     setHistory(newHistory);
                     setHistoryIndex(newHistory.length - 1);
                } else {
// Se il documento non esiste dopo la cancellazione, ricarica dal server
console.warn("Doc non trovato dopo cancellazione, ricarico dal server.");

const monthDocId = `${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}`;
const monthDocRef = doc(db, 'centers', userProfile.centerId, 'schedules', monthDocId);

try {
    const docSnap = await getDoc(monthDocRef);
    
    if (docSnap.exists() && docSnap.data().schedule) {
        // Il documento esiste, carica i dati
        const serverSchedule = JSON.parse(docSnap.data().schedule);
        
        // Carica anche i saturday assignments
        const satDocRef = doc(db, 'centers', userProfile.centerId, "rotation", "saturdays");
        const satDocSnap = await getDoc(satDocRef);
        const saturdayAssignments = satDocSnap.exists() ? satDocSnap.data().assignments : {};
        
        // Crea il nuovo stato
        const newScheduleData = {
            fullSchedule: serverSchedule,
            saturdayAssignments: saturdayAssignments
        };
        
        // Aggiorna lo stato React
        setScheduleData(newScheduleData);
        
        // Aggiorna la cronologia (come faceva prima)
        const currentStateAfterReload = { 
            schedule: JSON.parse(JSON.stringify(newScheduleData)), 
            metadata: {} 
        };
        const newHistory = history.slice(0, historyIndex + 1);
        newHistory.push(currentStateAfterReload);
        setHistory(newHistory);
        setHistoryIndex(newHistory.length - 1);
        
        toast.success("Calendario ricaricato dal server.");
    } else {
        // Il documento non esiste proprio, mostra messaggio all'utente
        console.warn("Nessun documento trovato per questo mese.");
        toast.warning("Nessun turno trovato per questo mese. Usa 'Genera Turni' per crearli.");
        
        // Pulisci lo stato locale
        setScheduleData({ fullSchedule: {}, saturdayAssignments: {} });
    }
} catch (error) {
    console.error("Errore durante il ricaricamento dopo cancellazione:", error);
    toast.error("Errore durante il ricaricamento. Ricarica la pagina.");
}
}

            } catch (error) {
                 console.error("Errore frontend cancellazione 0h:", error);
            }
        } else {
             console.warn("Nessuna richiesta trovata da cancellare per 0h:", dayStr);
             closeModal();
        }
        return; // Esce dopo aver gestito il caso 0h
    }

    if (isLeaveRequestType) {
        // Apri sempre il modale per le nuove richieste di assenza
        const isManagerForLeaves = leavesPermissionLevel !== 'self-edit';
        const confirmButtonText = isManagerForLeaves ? 'Aggiungi Assenza' : 'Invia Richiesta';

        setLeaveModalData({
            personId: personProfile.id,
            personName: personName,
            personProfileData: personProfile,
            selectedDate: dayStr,
            leaveType: null,  // null = l'utente sceglie dal dropdown del LeaveRequestModal
            leaveHours: undefined,
            confirmText: isManagerForLeaves ? 'Aggiungi Assenza' : 'Invia Richiesta',
            effectivePermissionLevel: leavesPermissionLevel
        });
        setIsLeaveModalOpen(true);
        closeModal(); // Chiudi il modale 'change-shift'
        return; // <-- FERMA L'ESECUZIONE QUI per forzare il flusso del modale
    }

    // --- Gestione Altri Cambi Turno (non Assenze o cancellazione permesso 0h) ---
    // Questa parte viene eseguita SOLO se non siamo nei casi precedenti
    const proceedWithChange = async (leaveRequestIdToCancel = null) => {

        // 🎯 FIX CHIRURGICO: Gestione cancellazione pulita SOLO della cella selezionata
        if (newShiftName === 'CANCELLA_TURNO') {
            const newSchedule = JSON.parse(JSON.stringify(scheduleData));
            
            if (newSchedule.fullSchedule[dayStr]) {
                // Elimina rigorosamente solo il turno per questa persona in questo giorno
                delete newSchedule.fullSchedule[dayStr][personProfile.id];
                delete newSchedule.fullSchedule[dayStr][personName]; // Pulizia eventuali refusi vecchi
            }
            
            await updateSchedule(newSchedule);
            closeModal();
            toast.success("Cella svuotata correttamente.");
            return;
        }
        // --- FINE FIX ---

         if (leaveRequestIdToCancel) {
             try {
                await reverseLeaveAbsence({ requestId: leaveRequestIdToCancel, centerId: userProfile.centerId }); // <-- MODIFICA QUI
                toast.success("Giorno di assenza annullato e contatori aggiornati.");
            } catch (error) {
                console.error("Errore durante lo storno dell'assenza:", error);
                toast.error("Errore durante l'aggiornamento dei contatori.");
                closeModal();
                return;
            }
        }

        if (newShiftName === 'AGGIUNGI_SABATO' || newShiftName === 'RIMUOVI_SABATO') {
            handleSaturdayManualChange(personName, dayStr, newShiftName); // ✅ USA personName
            return;
        }

        const newSchedule = JSON.parse(JSON.stringify(scheduleData));
        const daySchedule = newSchedule.fullSchedule[dayStr] || {};
        if (!daySchedule[personProfile.id]) daySchedule[personProfile.id] = {};

        const SECRETARIES = staffData.filter(s => s.role === 'Segretaria').map(s => s.name);
        const swappableShifts = baseShifts; 
        const isSwappable = swappableShifts.includes(newShiftName);

        if (isSwappable && SECRETARIES.includes(personName)) { // ✅ USA personName
            // MODIFICA QUI: Usiamo filter invece di find per trovare TUTTI i candidati
            const candidates = staffData
    .filter(s => s.role === 'Segretaria' && s.name !== personName) // Prendi le altre segretarie
    .filter(s => {
        // Controlla se hanno quel turno (cercando sia per ID che per Nome)
        const sShift = daySchedule[s.id] || daySchedule[s.name];
        return sShift?.name === newShiftName;
    })
    .map(s => s.name);
            
            const originalShiftOfPerson = daySchedule[personProfile.id]?.name || daySchedule[personName]?.name; // ✅ USA personName

            // *** 3. Logica del Popup "Scambia o Modifica" ***
            // Se c'è almeno un candidato (o più di uno)
            if (candidates.length > 0) {
                console.log("Rilevati potenziali scambi:", candidates);
                setModal({
                    type: 'swap-or-modify',
                    data: {
                        choiceData: data, 
                        candidates: candidates, // Passiamo l'array dei nomi
                        originalShiftOfPerson: originalShiftOfPerson || 'Vuoto' 
                    }
                });
                return; // Interrompe l'esecuzione di proceedWithChange
            } else {
// Assicurati che l'oggetto esista
if (!daySchedule[personProfile.id]) daySchedule[personProfile.id] = {};
// Scrivi sull'ID
daySchedule[personProfile.id].name = newShiftName;
daySchedule[personProfile.id].originalName = newShiftName; // 🌟 AGGIUNGI QUESTA RIGA
 // Reset fields
daySchedule[personProfile.id].overtime = {h: 0, m: 0};
daySchedule[personProfile.id].leave = {h: 0, m: 0};
daySchedule[personProfile.id].recovery = {h: 0, m: 0};
daySchedule[personProfile.id].customTime = null;
}

        } else { // Gestione altri tipi di turno o non segreteria
             let currentShift = daySchedule[personProfile.id] || daySchedule[personName] || {}; // ✅ USA personName

            if (newShiftName === 'Sabato') {
                const originalWorker = Object.keys(daySchedule).find(p => daySchedule[p]?.name === 'Sabato');
                setModal({ type: 'saturday-type', data: { person: personName, dayStr, originalWorker } }); // ✅ USA personName
                return;
            }
            // ATTENZIONE: Rimuoviamo 'Permesso' da questo blocco if perché deve essere gestito sopra
             if (newShiftName === 'Straordinario' || newShiftName === 'AggiungiRecupero' || newShiftName === 'TogliRecupero') {
                if (newShiftName === 'Straordinario') currentShift.overtime = overtime;
                if (newShiftName === 'AggiungiRecupero') currentShift.recovery = recovery;
                else if (newShiftName === 'TogliRecupero') currentShift.recovery = {h: 0, m: 0};

                if (newShiftName === 'AggiungiRecupero' || newShiftName === 'TogliRecupero') {
                if (currentShift.name && currentShift.name !== 'Nuovo Orario') {
                    const staffMember = staffData.find(s => s.name === personName); // ✅ USA personName
                    if (staffMember?.role !== 'Segretaria') {
                        // --- INIZIO LOGICA CORRETTA (NON-SEGRETARIA) ---
                        const isAdding = newShiftName === 'AggiungiRecupero';

                        // 1. Trova il nome base del turno (es. "Mattina" da "Mattina REC")
                        // Usiamo originalName se esiste, altrimenti il nome corrente
                        const currentBaseName = (currentShift.originalName || currentShift.name).replace(' REC', '').trim();
                        let targetSlot = null;

                        if (isAdding) {
                            // 2. Se AGGIUNGO, cerco il turno REC corrispondente VALIDO OGGI
                            targetSlot = staffMember.timeSlots.find(ts => 
                                ts.isRecovery && 
                                ts.name.includes(currentBaseName) &&
                                moment(dayStr).isBetween(ts.validFrom || "2020-01-01", ts.validUntil || "2100-01-01", 'day', '[]')
                            );
                        } else {
                            // 3. Se TOLGO, cerco il turno NON-REC corrispondente VALIDO OGGI
                            targetSlot = staffMember.timeSlots.find(ts => 
                                !ts.isRecovery && 
                                ts.name === currentBaseName &&
                                moment(dayStr).isBetween(ts.validFrom || "2020-01-01", ts.validUntil || "2100-01-01", 'day', '[]')
                            );
                        }

                        if (targetSlot) {
                            // 4. Applica il nome e lo stato REC trovati
                            currentShift.name = targetSlot.name;
                            currentShift.isRecovery = targetSlot.isRecovery;
                            currentShift.originalName = targetSlot.name; // Aggiorna l'originale
                        } else {
                            // 5. Fallback (soprattutto per TogliRecupero)
                            console.warn(`Nessuna fascia oraria trovata per ${newShiftName} su base ${currentBaseName} valida il ${dayStr}`);
                            if (!isAdding) {
                                // Se sto togliendo e non trovo, forzo la rimozione
                                currentShift.name = currentBaseName;
                                currentShift.isRecovery = false;
                                currentShift.originalName = currentBaseName;
                            }
                        }
                        // --- FINE LOGICA CORRETTA (NON-SEGRETARIA) ---
                    } else {
// Logica per Segretaria (FIXED)
const isAdding = (newShiftName === 'AggiungiRecupero');
currentShift.isRecovery = isAdding;

// Pulisci o aggiungi " REC" dal nome per coerenza
const baseName = (currentShift.originalName || currentShift.name).replace(' REC', '').trim();
if (isAdding) {
    currentShift.name = `${baseName} REC`;
} else {
    currentShift.name = baseName;
}
currentShift.originalName = currentShift.name;
}
                } else if (!currentShift.name) {
                    console.warn("Impossibile agg/togliere recupero senza turno base.");
                }
            }
                daySchedule[personProfile.id] = currentShift;

            } else { // Imposta un nuovo turno base (Mattina, Pom, Chiusura, Ufficio, Nuovo Orario)
                 const newShiftData = { // Logica invariata
                    name: newShiftName,
                    originalName: newShiftName, // 🌟 AGGIUNGI QUESTA RIGA
                    overtime: (swappableShifts.includes(newShiftName) || newShiftName === 'standard' || newShiftName === 'Nuovo Orario') ? (currentShift.overtime || {h: 0, m: 0}) : {h: 0, m: 0},
                    leave: {h:0, m:0}, // Resetta permessi quando cambi turno base
                    recovery: newShiftName === 'Nuovo Orario' 
? (recovery || {h: 0, m: 0})  // <-- FIX: Se è Nuovo Orario, usa il payload 'recovery' in arrivo
: ((swappableShifts.includes(newShiftName) || newShiftName === 'standard') 
    ? (currentShift.recovery || {h: 0, m: 0}) // Altrimenti, preserva il recupero esistente
    : {h: 0, m: 0}), // Altrimenti, resetta
                    isRecovery: (swappableShifts.includes(newShiftName) || newShiftName === 'standard') ? (currentShift.isRecovery || false) : false,
                    customTime: newShiftName === 'Nuovo Orario' ? customTime : null
                };
                daySchedule[personProfile.id] = newShiftData;
            }
        }

        newSchedule.fullSchedule[dayStr] = daySchedule;
        await updateSchedule(newSchedule);

         const targetPersonProfile = staffData.find(staff => staff.name === personName); // ✅ USA personName
        if (targetPersonProfile && userProfile.uid !== targetPersonProfile.id) {
             const formattedDate = moment(dayStr).format('DD/MM');
             await createNotification(
                targetPersonProfile.id,
                userProfile,
                `ha modificato il tuo turno del ${formattedDate} in "${newShiftName}"`,
                '/turni'
             );
        }

        closeModal();
    }; // <-- Fine proceedWithChange

    // Controllo storno assenza (logica invariata)
    const originalShiftName = originalShift?.name;
    if (originalShiftName === 'Ferie' || originalShiftName === 'Malattia' || (originalShiftName === 'Permesso' && (originalShift?.leave?.h > 0 || originalShift?.leave?.m > 0))) {
        let requestTypeToSearch = originalShiftName;
        if (originalShiftName === 'Permesso') {
             requestTypeToSearch = ["Permesso retribuito (ROL)", "Permesso non retribuito"];
        } else {
             requestTypeToSearch = [originalShiftName];
        }
         const q = query(collection(db, 'centers', userProfile.centerId, "leaveRequests"), // <-- MODIFICA QUI
            where("userId", "==", personProfile.id),
            where("startDate", "<=", dayStr),
            where("endDate", ">=", dayStr),
            where("type", "in", requestTypeToSearch)
        );
        const querySnapshot = await getDocs(q);
        const relevantRequest = querySnapshot.docs.length > 0 ? querySnapshot.docs[0] : null;

        if (relevantRequest) {
            setModal({
                type: 'custom-confirmation',
                data: {
                    title: `Conferma Sostituzione ${originalShiftName}`,
                    message: `Questo giorno è registrato come ${relevantRequest.data().type}. Vuoi annullare il giorno di assenza e sostituirlo con il nuovo turno?`,
                    onConfirm: () => proceedWithChange(relevantRequest.id)
                }
            });
        } else {
            proceedWithChange();
        }
    } else {
        proceedWithChange();
    }
}; // <-- Fine handleShiftChange

   // --- FUNZIONE CORRETTA: GESTISCE ID E NOME CORRETTAMENTE ---
const handleSwapOrModifyChoice = async (choice, data) => {
    const { choiceData, candidates, originalShiftOfPerson } = data;
    
    // 1. CORREZIONE: Estraiamo personId e personName correttamente
    // (Prima cercava "person" che non esisteva, causando l'errore)
    const { personId, personName, newShiftName } = choiceData; 
    
    // Nome della persona con cui scambiare (se scelta)
    const targetSwapName = data.targetSwapName || data.personToSwapWith;

    // 2. CORREZIONE: Cerchiamo il profilo usando l'ID (più sicuro)
    // Fallback sul nome solo se l'ID non dovesse esserci
    const personProfile = staffData.find(p => p.id === personId) || staffData.find(p => p.name === personName);
    
    if (!personProfile) {
        console.error("Impossibile trovare il profilo dell'utente corrente:", personId, personName);
        toast.error("Errore critico: profilo utente non trovato.");
        closeModal();
        return;
    }
    
    // Usiamo l'ID trovato dal profilo confermato
    const currentPersonId = personProfile.id;
    console.log(`Scelta utente: ${choice} per ${personProfile.name} (ID: ${currentPersonId})`);

    const newSchedule = JSON.parse(JSON.stringify(scheduleData));
    const daySchedule = newSchedule.fullSchedule[choiceData.dayStr] || {};

    // Funzione helper per resettare i campi
    const resetShiftFields = (pId) => {
        if (daySchedule[pId]) {
            daySchedule[pId].overtime = { h: 0, m: 0 };
            daySchedule[pId].leave = { h: 0, m: 0 };
            daySchedule[pId].recovery = { h: 0, m: 0 };
            daySchedule[pId].customTime = null;
        }
    };

    if (choice === 'swap') {
        // --- LOGICA SCAMBIO ---
        
        // Qui dobbiamo cercare l'ALTRA persona tramite il NOME, 
        // perché l'array 'candidates' contiene nomi (es. "Claudia", "Tiziana")
        const swapPersonProfile = staffData.find(p => p.name === targetSwapName);

        if (!swapPersonProfile) {
            console.error(`Impossibile trovare il profilo per lo scambio: ${targetSwapName}`);
            toast.error(`Errore: impossibile trovare il profilo di ${targetSwapName} per lo scambio.`);
            closeModal();
            return;
        }

        const swapPersonId = swapPersonProfile.id;
        console.log(`Eseguo SCAMBIO: ${personProfile.name} <-> ${targetSwapName}`);

        // 1. Assegna il NUOVO turno all'utente corrente (ID)
        // Assicuriamoci che l'oggetto esista
        if (!daySchedule[currentPersonId]) daySchedule[currentPersonId] = {};
        daySchedule[currentPersonId] = { ...daySchedule[currentPersonId], name: newShiftName, originalName: newShiftName }; // 🌟 AGGIUNTA
        
        // 2. Assegna il VECCHIO turno dell'utente corrente all'altro utente (ID)
        if (!daySchedule[swapPersonId]) daySchedule[swapPersonId] = {};
        daySchedule[swapPersonId] = { ...daySchedule[swapPersonId], name: originalShiftOfPerson, originalName: originalShiftOfPerson }; // 🌟 AGGIUNTA

        // Resetta i campi per entrambe le persone
        resetShiftFields(currentPersonId);
        resetShiftFields(swapPersonId);

        // Notifica per la persona con cui hai scambiato
        try {
            if (userProfile.uid !== swapPersonProfile.id) {
                 await createNotification(
                    swapPersonProfile.id,
                    userProfile,
                    `ha scambiato il tuo turno del ${moment(choiceData.dayStr).format('DD/MM')} con ${personProfile.name}. Nuovo turno: "${originalShiftOfPerson}"`,
                    '/turni'
                 );
            }
        } catch (e) { console.error(e); }

    } else {
        // --- LOGICA MODIFICA SOLO QUESTO ---
        console.log(`Eseguo MODIFICA SOLO per: ${personProfile.name}`);
        
        if (!daySchedule[currentPersonId]) daySchedule[currentPersonId] = {};
daySchedule[currentPersonId] = { ...daySchedule[currentPersonId], name: newShiftName, originalName: newShiftName }; // 🌟 AGGIUNTA        
        // Resetta i campi SOLO per la persona modificata
        resetShiftFields(currentPersonId);
    }
    
    newSchedule.fullSchedule[choiceData.dayStr] = daySchedule;
    await updateSchedule(newSchedule);

    // Notifica per l'utente modificato (se non sei tu che modifichi te stesso)
    try {
        if (userProfile.uid !== personProfile.id) {
             await createNotification(
                personProfile.id,
                userProfile,
                `ha modificato il tuo turno del ${moment(choiceData.dayStr).format('DD/MM')} in "${newShiftName}"`,
                '/turni'
             );
        }
    } catch (notifError) {
        console.error("Errore invio notifica:", notifError);
    }
    
    closeModal();
};

const handleUndo = async () => {
        console.log("%c--- handleUndo CHIAMATA! ---", "color: green; font-weight: bold;");
        console.log("Stato attuale:", { historyIndex, historyLength: history.length });

        if (historyIndex <= 0) {
            console.log("-> Undo bloccato: historyIndex <= 0");
            return;
        }

        // --- IMPOSTA FLAG ---
        isProcessingUndoRedo.current = true;
        console.log("-> Undo: Impostato isProcessingUndoRedo a true");

        const currentState = history[historyIndex];
        const previousStateEntry = history[historyIndex - 1];
        const newIndex = historyIndex - 1;

        // ID per questa operazione di Undo
        const undoOperationId = Date.now();
        console.log(`-> Undo: Generato Op ID ${undoOperationId}`);

        try {
            // Caso 1: Annullamento Creazione Richiesta (usa CF)
            if (currentState.metadata?.createdLeaveRequestId) {
            console.log("-> Undo: Annullamento creazione richiesta ID:", currentState.metadata.createdLeaveRequestId);

            // Aggiorna il REF locale PRIMA della chiamata asincrona
            lastLocalOperationIdRef.current = undoOperationId; // Usa l'ID generato per l'UNDO
            console.log(`   (Aggiornato lastLocalOperationIdRef a ${undoOperationId} per Undo Leave)`);

            await toast.promise(
            cancelLeaveRequest({ requestId: currentState.metadata.createdLeaveRequestId, centerId: userProfile.centerId }), // <-- MODIFICA QUI
                { /* opzioni toast */ }
            );
            console.log("-> Undo richiesta: Chiamata backend OK.");

            // !!! MODIFICA CRUCIALE: Aggiorna SOLO l'indice !!!
            setHistoryIndex(newIndex);
            // NON chiamare setScheduleData qui.
            // onSnapshot riceverà l'aggiornamento dal backend (fatto da cancelLeaveRequest)
            // e sincronizzerà l'UI e la cronologia se necessario.

        }
            // Caso 2: Annullamento Cambio Diretto (aggiorna locale + salva DB)
            else {
                const previousScheduleData = previousStateEntry?.schedule; // Usa optional chaining
                if (!previousScheduleData) {
                    throw new Error("Stato precedente non trovato nella cronologia!");
                }
                console.log("-> Undo: Cambio diretto. Ripristino stato:", previousScheduleData);

                // Aggiorna il REF locale PRIMA di aggiornare stato React e salvare
                lastLocalOperationIdRef.current = undoOperationId;
                 console.log(`   (Aggiornato lastLocalOperationIdRef a ${undoOperationId} per Undo diretto)`);

                // 1. Aggiorna UI locale
                setScheduleData(previousScheduleData);
                // 2. Aggiorna indice locale
                setHistoryIndex(newIndex);

                // 3. Salva lo stato ripristinato su Firebase, passando il nuovo ID
                console.log("-> Salvataggio stato ripristinato (Undo) su Firebase...");
                await saveScheduleToFirebase(previousScheduleData, false, undoOperationId); // Passa undoOperationId
                console.log("-> Salvataggio Firebase (Undo) completato.");
                toast.info("Azione annullata.");
            }
        } catch (error) {
             console.error("-> Errore durante l'operazione di Undo:", error);
             toast.error(`Errore durante l'annullamento: ${error.message || 'Errore sconosciuto'}`);
             // Considera rollback locale qui?
             // isProcessingUndoRedo.current = false; // Il finally lo fa già
        } finally {
            // --- RESETTA FLAG SEMPRE ---
            isProcessingUndoRedo.current = false;
            console.log("-> Undo: Reimpostato isProcessingUndoRedo a false");
            console.log("--- handleUndo FINE --- Nuovo historyIndex:", newIndex);
        }
    };

const handleRedo = async () => {
        console.log("%c--- handleRedo CHIAMATA! ---", "color: green; font-weight: bold;");
        console.log("Stato attuale:", { historyIndex, historyLength: history.length });

        if (historyIndex >= history.length - 1) {
            console.log("-> Redo bloccato: già allo stato più recente.");
            return;
        }

        // --- IMPOSTA FLAG ---
        isProcessingUndoRedo.current = true;
        console.log("-> Redo: Impostato isProcessingUndoRedo a true");

        const newIndex = historyIndex + 1;
        const nextStateEntry = history[newIndex];
        const nextScheduleData = nextStateEntry?.schedule; // Usa optional chaining

        // ID per questa operazione di Redo
        const redoOperationId = Date.now();
        console.log(`-> Redo: Generato Op ID ${redoOperationId}`);

        try {
            if (!nextScheduleData) {
                 throw new Error("Stato successivo non trovato nella cronologia!");
            }
            console.log("-> Redo: Ripristino stato:", nextScheduleData);

            // Aggiorna il REF locale PRIMA di aggiornare stato React e salvare
            lastLocalOperationIdRef.current = redoOperationId;
             console.log(`   (Aggiornato lastLocalOperationIdRef a ${redoOperationId} per Redo)`);

            // 1. Aggiorna UI locale
            setScheduleData(nextScheduleData);
            // 2. Aggiorna indice locale
            setHistoryIndex(newIndex);

            // 3. Salva lo stato ripristinato (Redo) su Firebase, passando il nuovo ID
            console.log("-> Salvataggio stato ripristinato (Redo) su Firebase...");
            await saveScheduleToFirebase(nextScheduleData, false, redoOperationId); // Passa redoOperationId
            console.log("-> Salvataggio Firebase (Redo) completato.");
            toast.info("Azione ripristinata.");

        } catch (error) { // Cattura sia l'errore dello stato non trovato sia quello del salvataggio
            console.error("-> Errore durante l'operazione di Redo:", error);
            toast.error(`Errore durante il ripristino: ${error.message || 'Errore sconosciuto'}`);
             // Considera rollback locale qui?
             // isProcessingUndoRedo.current = false; // Il finally lo fa già
        } finally {
            // --- RESETTA FLAG SEMPRE ---
            isProcessingUndoRedo.current = false;
            console.log("-> Redo: Reimpostato isProcessingUndoRedo a false");
            console.log("--- handleRedo FINE --- Nuovo historyIndex:", newIndex);
        }
    };

const handleLeaveRequestSubmit = async (requestData) => {
    // --- Inizio: Logica per determinare lo stato iniziale CORRETTA ---
    const leavesPermission = userProfile?.permissions?.leaves || 'none';
    const isFullManager = leavesPermission === 'completo';
    const isSemiManager = leavesPermission === 'semi-completo';
    const isManager = isFullManager || isSemiManager;
    
    // self-edit standard (non manager)
    const isSelfEditUser = leavesPermission === 'self-edit'; 

    const targetPersonId = leaveModalData.personId;
    const isRequestForSelf = targetPersonId === userProfile.uid;
    const targetPersonProfile = staffData.find(p => p.id === targetPersonId);

    if (!targetPersonProfile) {
         toast.error("Errore: Profilo utente non trovato per la richiesta.");
         setIsLeaveModalOpen(false);
         return;
    }
    const totalDays = moment(requestData.endDate).diff(moment(requestData.startDate), 'days') + 1;
    let status = 'pending'; // Default a pending
    const isPastDate = moment(requestData.endDate).isBefore(moment(), 'day');

    // Logica Approvazione Automatica CORRETTA
    if (
        requestData.type === 'Malattia' ||
        requestData.type === 'Permesso 104' ||
        isFullManager || // 1. Chi ha controllo COMPLETO approva sempre tutto
        (isSemiManager && !isRequestForSelf) || // 2. Chi ha SEMI-COMPLETO approva solo per ALTRI
        (isManager && requestData.type.includes('Permesso')) || 
        (isSelfEditUser && isRequestForSelf && requestData.type.includes('Permesso') && isPastDate)
       )
    {
        status = 'approved';
    }
    
    try {
        const start = moment(requestData.startDate);
        const end = moment(requestData.endDate);
        const personId = leaveModalData.personId;
        const originalShifts = {};
        // --- Recupero Original Shifts dallo stato LOCALE CORRENTE (scheduleData) ---
        for (let day = start.clone(); day.isSameOrBefore(end); day.add(1, 'day')) {
            const dayStr = day.format('YYYY-MM-DD');
            originalShifts[dayStr] = scheduleData.fullSchedule[dayStr]?.[personId] || scheduleData.fullSchedule[dayStr]?.[leaveModalData.personName] || {};
        }
        
        // --- Creazione Documento Richiesta ---
        const requestPayload = {
            userId: leaveModalData.personId, userName: leaveModalData.personName, type: requestData.type,
            startDate: requestData.startDate, endDate: requestData.endDate, totalDays: totalDays,
            notes: requestData.notes.trim(), status: status, requestedAt: new Date(), originalShifts,
            centerId: userProfile.centerId,
            ...(requestData.leave && { leaveHours: requestData.leave })
        };
        const newRequestRef = await addDoc(collection(db, 'centers', userProfile.centerId, 'leaveRequests'), requestPayload);
        
        // --- Aggiornamento stato LOCALE ---
        const newSchedule = JSON.parse(JSON.stringify(scheduleData)); 
        for (let day = start.clone(); day.isSameOrBefore(end); day.add(1, 'day')) {
            const dayStr = day.format('YYYY-MM-DD');
            if (!newSchedule.fullSchedule[dayStr]) newSchedule.fullSchedule[dayStr] = {};
            const existingShift = newSchedule.fullSchedule[dayStr]?.[personId] || newSchedule.fullSchedule[dayStr]?.[leaveModalData.personName] || {};

            if (requestData.type.includes("Permesso")) {
                newSchedule.fullSchedule[dayStr][personId] = { ...existingShift, leave: requestData.leave || {h: 0, m: 0} };
            } else { 
                newSchedule.fullSchedule[dayStr][personId] = { name: requestData.type, isRecovery: false, overtime: {h: 0, m: 0}, leave: {h: 0, m: 0}, recovery: {h: 0, m: 0} };
            }
        }

        await updateSchedule(newSchedule, { createdLeaveRequestId: newRequestRef.id });

        // --- Chiamata Cloud Function ---
        if (status === 'approved') {
            toast.promise(
                processLeaveApproval({ requestId: newRequestRef.id, centerId: userProfile.centerId }),
                {
                  pending: 'Aggiornamento contatori...', 
                  success: 'Contatori assenze aggiornati!',
                  error: "Errore durante l'aggiornamento dei contatori."
                }
            ).catch(cfError => {
                 console.error(`Errore da processLeaveApproval per ${newRequestRef.id}:`, cfError);
            });
        } else { 
             toast.success("Richiesta inviata con successo!"); 
        }

        setIsLeaveModalOpen(false); 

    } catch (err) {
        console.error("Errore generale in handleLeaveRequestSubmit: ", err);
        toast.error(`Si è verificato un errore: ${err.message || 'Riprova.'}`);
        setIsLeaveModalOpen(false);
    }
};
    
    const handleSaturdayChange = async (type) => {
    const { person, dayStr, originalWorker } = modal.data;
    const newSchedule = JSON.parse(JSON.stringify(scheduleData));

    if (type === 'swap') {
        const newSaturdayAssignments = { ...newSchedule.saturdayAssignments };
        const keyForDay = Object.keys(newSaturdayAssignments).find(date => moment(date).isSame(dayStr, 'day'));
        if (keyForDay) delete newSaturdayAssignments[keyForDay];
        newSaturdayAssignments[dayStr] = { person };

        // ✅ PREPARA LO SCHEDULE MODIFICATO PER LO SCAMBIO
        const modifiedSchedule = JSON.parse(JSON.stringify(scheduleData)); // Clona
        const weekStartOfChange = moment(dayStr).clone().startOf('isoWeek');
        const personProfile = staffData.find(s => s.name === person);
        const originalWorkerProfile = staffData.find(s => s.name === originalWorker);

        // Applica lo scambio localmente (su modifiedSchedule)
        if (originalWorkerProfile && personProfile) {
            for (let i = 0; i < 7; i++) { // Scambia tutti i 7 giorni
                const currentDayStr = weekStartOfChange.clone().add(i, 'days').format('YYYY-MM-DD');
                if (!modifiedSchedule.fullSchedule[currentDayStr]) modifiedSchedule.fullSchedule[currentDayStr] = {};
                const dayData = modifiedSchedule.fullSchedule[currentDayStr];

                const originalShift = dayData[originalWorkerProfile.id] || dayData[originalWorkerProfile.name];
                const newShift = dayData[personProfile.id] || dayData[personProfile.name];

                delete dayData[originalWorkerProfile.name]; // Pulisci
                delete dayData[personProfile.name]; // Pulisci
                if (newShift) dayData[originalWorkerProfile.id] = newShift; else delete dayData[originalWorkerProfile.id];
                if (originalShift) dayData[personProfile.id] = originalShift; else delete dayData[originalWorkerProfile.id];
            }
        }

        setModal({ 
            type: 'recalc-future', 
            data: { 
                ...modal.data, 
                newSaturdayAssignments,
                modifiedSchedule: modifiedSchedule // ✅ PASSA LO SCHEDULE MODIFICATO
            } 
        });

    } else if (type === 'overtime') { 
        const weekStart = moment(dayStr).startOf('isoWeek');
        const personProfile = staffData.find(s => s.name === person);
        const originalWorkerProfile = staffData.find(s => s.name === originalWorker);

        if (originalWorkerProfile) {
            delete newSchedule.fullSchedule[dayStr][originalWorkerProfile.id];
            delete newSchedule.fullSchedule[dayStr][originalWorkerProfile.name];
            // Togli REC al vecchio lavoratore
            for (let i = 1; i < 5; i++) {
                const day = weekStart.clone().add(i, 'days').format('YYYY-MM-DD');
                const shift = newSchedule.fullSchedule[day]?.[originalWorkerProfile.id] || newSchedule.fullSchedule[day]?.[originalWorkerProfile.name];
                if (shift) {
                    shift.isRecovery = false;
                    newSchedule.fullSchedule[day][originalWorkerProfile.id] = shift;
                }
            }
        }
        if (!newSchedule.fullSchedule[dayStr]) newSchedule.fullSchedule[dayStr] = {};
        newSchedule.fullSchedule[dayStr][personProfile.id] = { name: 'Sabato', overtime: { h: 4, m: 0 } };
        // NON aggiungere REC per straordinario
        updateSchedule(newSchedule);
        closeModal();

    } else if (type === 'simple') {
        // 🎯 FIX CHIRURGICO: Aggiunta Semplice (Senza toccare i REC di nessuno)
        const personProfile = staffData.find(s => s.name === person);
        const originalWorkerProfile = staffData.find(s => s.name === originalWorker);

        // 1. Rimuovo il vecchio lavoratore SOLO dal Sabato (se esiste)
        if (originalWorkerProfile) {
            delete newSchedule.fullSchedule[dayStr][originalWorkerProfile.id];
            delete newSchedule.fullSchedule[dayStr][originalWorkerProfile.name];
            // Nessun ciclo for: i suoi REC infrasettimanali restano intatti.
        }
        
        // 2. Assegno il Sabato alla nuova persona in modo neutro
        if (!newSchedule.fullSchedule[dayStr]) newSchedule.fullSchedule[dayStr] = {};
        newSchedule.fullSchedule[dayStr][personProfile.id] = { 
            name: 'Sabato', 
            originalName: 'Sabato',
            overtime: { h: 0, m: 0 }, 
            leave: { h: 0, m: 0 }, 
            recovery: { h: 0, m: 0 } 
        };
        
        updateSchedule(newSchedule);
        closeModal();
    }
};

    const formatMinutesToHM = (totalMinutes) => {
        if (!totalMinutes || totalMinutes === 0) return '00:00';
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    };

    const weeksInMonth = [];
    if (scheduleData.fullSchedule && Object.keys(scheduleData.fullSchedule).length > 0) {
        const firstDayOfMonth = moment([selectedYear, selectedMonth, 1]);
        const lastDayOfMonth = firstDayOfMonth.clone().endOf('month');
        let currentDate = firstDayOfMonth.clone().startOf('isoWeek');
        while (currentDate.isSameOrBefore(lastDayOfMonth)) {
            const week = Array.from({length: 7}, (_, i) => currentDate.clone().add(i, 'days'));
            weeksInMonth.push(week);
            currentDate.add(1, 'week');
        }
    }

    const handlePrint = () => { window.print(); };

    const handlePdfExport = (options) => {
        const { view } = options;
        const mainWrapper = document.getElementById('main-wrapper');
        const scheduleContainer = document.getElementById('schedule-container');
        const isMobileView = window.innerWidth <= 768;
        const activeHeaderId = isMobileView ? 'mobile-header' : 'main-header';
        const summaryContainer = document.getElementById(activeHeaderId).querySelector('.accordion');
        const wasInitiallyOpen = summaryContainer.querySelector('.accordion-content').classList.contains('open');
        mainWrapper.classList.add('export-mode');

        if (view === 'shifts') {
            summaryContainer.style.display = 'none';
        } else {
            const accordionContent = summaryContainer.querySelector('.accordion-content');
            if (!accordionContent.classList.contains('open')) {
                accordionContent.classList.add('open');
            }
        }

        const html2canvasOptions = { scale: 3, useCORS: true, backgroundColor: '#ffffff' };
        const monthName = moment([selectedYear, selectedMonth]).format('MMMM_YYYY');
        const fileName = `turni_${monthName}_${view}.pdf`;
        const elementToRender = view === 'summary' ? summaryContainer : mainWrapper;

        html2canvas(elementToRender, html2canvasOptions)
            .then(canvas => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });
                const A4_WIDTH_PT = 595.28;
                const A4_HEIGHT_PT = 841.89;
                const margin = 20;
                const availableWidth = A4_WIDTH_PT - (margin * 2);
                const availableHeight = A4_HEIGHT_PT - (margin * 2);
                const canvasAspectRatio = canvas.width / canvas.height;
                let renderWidth = availableWidth;
                let renderHeight = renderWidth / canvasAspectRatio;

                if (renderHeight > availableHeight) {
                    renderHeight = availableHeight;
                    renderWidth = renderHeight * canvasAspectRatio;
                }
                const xOffset = (A4_WIDTH_PT - renderWidth) / 2;
                const yOffset = (A4_HEIGHT_PT - renderHeight) / 2;
                pdf.addImage(imgData, 'PNG', xOffset, yOffset, renderWidth, renderHeight);
                pdf.save(fileName);
            })
            .finally(() => {
                mainWrapper.classList.remove('export-mode');
                scheduleContainer.style.display = '';
                summaryContainer.style.display = '';
                if (!wasInitiallyOpen) {
                    summaryContainer.querySelector('.accordion-content').classList.remove('open');
                }
                closeModal();
            });
    };

    const exportSchedule = (format) => {
        const elementToCapture = document.getElementById('schedule-container');
        const mainWrapper = document.getElementById('main-wrapper');
        if (!elementToCapture) return;

        const monthName = moment([selectedYear, selectedMonth]).format('MMMM_YYYY');
        const fileName = `turni_${monthName}.${format}`;
        const options = { scale: 2, useCORS: true, backgroundColor: '#f2f2f2' };
        mainWrapper.classList.add('export-mode');
        html2canvas(elementToCapture, options).then(canvas => {
           if (format === 'jpeg') {
                const imgData = canvas.toDataURL('image/jpeg', 1.0);
                const link = document.createElement('a');
                link.href = imgData;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else if (format === 'pdf') {
                const imgData = canvas.toDataURL('image/png');
                const A4_WIDTH_PT = 595.28;
                const A4_HEIGHT_PT = 841.89;
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });
                const canvasAspectRatio = canvas.width / canvas.height;
                let renderWidth = A4_WIDTH_PT;
                let renderHeight = renderWidth / canvasAspectRatio;
                if (renderHeight > A4_HEIGHT_PT) {
                    renderHeight = A4_HEIGHT_PT;
                    renderWidth = renderHeight * canvasAspectRatio;
                }
                const xOffset = (A4_WIDTH_PT - renderWidth) / 2;
                const yOffset = (A4_HEIGHT_PT - renderHeight) / 2;
                pdf.addImage(imgData, 'PNG', xOffset, yOffset, renderWidth, renderHeight);
                pdf.save(fileName);
            }
        }).finally(() => {
            mainWrapper.classList.remove('export-mode');
        });
    };
        
    return (
        <>
            <style>{styles}</style>
            
            {isLeaveModalOpen && (
                 <LeaveRequestModal
                    onClose={() => setIsLeaveModalOpen(false)}
                    personId={leaveModalData.personId} 
                    personName={leaveModalData.personName}
                    selectedDate={leaveModalData.selectedDate}
                    leaveType={leaveModalData.leaveType}
                    leaveHours={leaveModalData.leaveHours} 
                    confirmText={leaveModalData.confirmText}
                    onSubmit={handleLeaveRequestSubmit}
                    effectivePermissionLevel= {leavesPermissionLevel}
                />
            )}
            {isMobileMenuOpen && (
                <div className="mobile-menu-overlay" onClick={() => setIsMobileMenuOpen(false)}>
                    <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
                        <div className="mobile-menu-header">
                            <h3>Menu Navigazione</h3>
                            <button onClick={() => setIsMobileMenuOpen(false)} className="close-menu-btn">✖</button>
                        </div>
                        <div className="mobile-menu-content">
                            <h4>Anno ed Esporta</h4>
                            <div className="year-export-row">
                                <div className="mobile-year-selector">
                                    <select id="year-selector-mobile" value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value))}>
                                        {Array.from({ length: 26 }, (_, i) => 2025 + i).map((year) => (<option key={year} value={year}>{year}</option>))}
                                    </select>
                                </div>
                                <div className="print-export-buttons mobile">
                                    <button title="Stampa" onClick={handlePrint}><img src="/STAMPA.png" alt="Stampa" width={25} height={25} /></button>
                                    <button title="Esporta come JPG" onClick={() => exportSchedule("jpeg")}><img src="/JPEG.png" alt="Esporta come JPG" width={25} height={25} /></button>
                                    <button title="Esporta come PDF" onClick={() => setModal({ type: "export-pdf-options" })}><img src="/PDF.png" alt="Esporta come PDF" width={25} height={25} /></button>
                                </div>
                            </div>
                            <h4>Seleziona Mese</h4>
                            <div className="mobile-months-list">
                                {moment.months().map((month, index) => (
                                    <button key={month} className={selectedMonth === index ? "active" : ""} onClick={() => { setSelectedMonth(index); setIsMobileMenuOpen(false); }}>{month}</button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div id="main-wrapper">
                <div id="main-header" className="desktop-only">
                    <div id="navigation-controls">
                        <div className="nav-left">
                            <label htmlFor="year-selector">Anno:</label>
                            <select id="year-selector" value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value))}>
                                {Array.from({ length: 26 }, (_, i) => 2025 + i).map(year => (<option key={year} value={year}>{year}</option>))}
                            </select>
                        </div>
                        <div id="month-tabs">
                            {moment.months().map((month, index) => (
                                <button key={month} className={selectedMonth === index ? 'active' : ''} onClick={() => setSelectedMonth(index)}>{month}</button>
                            ))}
                        </div>
                        <div className="nav-right">
                             <div className="action-buttons">
                               <button title="Stampa" onClick={handlePrint}><img src="/STAMPA.png" alt="Stampa" width={25} height={25} /></button>
                               <button title="Esporta come JPG" onClick={() => exportSchedule('jpeg')}><img src="/JPEG.png" alt="Esporta come JPG" width={25} height={25} /></button>
                               <button title="Esporta come PDF" onClick={() => setModal({ type: 'export-pdf-options' })}><img src="/PDF.png" alt="Esporta come PDF" width={25} height={25} /></button>
                               
                               {(canEditAll || canEditSelf) && (
                                   <>
                                       <button title="Annulla" onClick={() => {
                                            console.log('--- PULSANTE ANNULLA MOBILE CLICCATO! ---'); 
                                            handleUndo();
                                         }}
                                            disabled={historyIndex <= 0}
                                        >
                                            <img src="/ANNULLA.png" alt="Annulla" width={25} height={25} />
                                    </button>
                                       <button title="Ripristina" onClick={handleRedo} disabled={historyIndex >= history.length - 1}><img src="/RIPRISTINA.png" alt="Ripristina" width={25} height={25} /></button>
                                   </>
                               )}
                            </div>
                        </div>
                    </div>
                    <div className="accordion">
                        <button className={`accordion-toggle ${isAccordionOpen ? 'open' : ''}`} onClick={() => setIsAccordionOpen(!isAccordionOpen)}>
                            Riepilogo Mese {isAccordionOpen ? '▲' : '▼'}
                        </button>
                        <div className={`accordion-content ${isAccordionOpen ? 'open' : ''}`}>
                            {monthlyStats && (
                                <table className="summary-table">
                                <thead>
                                     <tr>
                                         <th>Segretaria</th>
                                         <th>Ore Ordinarie</th>
                                        <th>Straordinario</th>
                                        <th>Permesso</th>
                                        <th>Ferie</th>
                                        <th>Malattia</th>
                                    </tr>
                                </thead>
                                    <tbody>
                                        {/* 🆕 filteredStaffData invece di staffData: rispetta la tab aperta (Turnazione/BackOffice) */}
                                        {filteredStaffData.map(person => (
                                            monthlyStats[person.id] && (
                                                <tr key={person.name} style={{backgroundColor: 'white'}}>
                                                    <td style={{backgroundColor: person.color, color: getContrastColor(person.color)}}>{person.name}</td>
                                                    <td>{formatMinutesToHM(monthlyStats[person.id].OrdinaryMinutes)}</td>
                                                    <td className="summary-overtime">{formatMinutesToHM(monthlyStats[person.id].OvertimeMinutes)}</td>
                                                    <td className="summary-leave">{formatMinutesToHM(monthlyStats[person.id].LeaveMinutes)}</td>
                                                    <td>{monthlyStats[person.id].Ferie > 0 ? `${monthlyStats[person.id].Ferie} gg` : '-'}</td>
                                                    <td>{monthlyStats[person.id].Malattia > 0 ? `${monthlyStats[person.id].Malattia} gg` : '-'}</td>
                                                </tr>
                                            )
                                        ))}
                                    </tbody>
                             </table>
                            )}
                        </div>
                    </div>
                </div>
                
                <div id="mobile-header" className="mobile-only">
                    <div className="mobile-header-top">
                        <button className="hamburger-btn" onClick={() => setIsMobileMenuOpen(true)}>☰</button>
                        <div className="mobile-actions">
                            {(canEditAll || canEditSelf) && (
                                <>
                                    <button title="Annulla" onClick={() => {
                                            console.log('--- PULSANTE ANNULLA MOBILE CLICCATO! ---'); 
                                            handleUndo();
                                         }}
                                            disabled={historyIndex <= 0}
                                        >
                                            <img src="/ANNULLA.png" alt="Annulla" width={25} height={25} />
                                    </button>
                                    <button title="Ripristina" onClick={handleRedo} disabled={historyIndex >= history.length - 1}><img src="/RIPRISTINA.png" alt="Ripristina" width={25} height={25} /></button>
                                </>
                             )}
                        </div>
                    </div>
                    <div className="accordion">
                        <button className={`accordion-toggle ${isAccordionOpen ? 'open' : ''}`} onClick={() => setIsAccordionOpen(!isAccordionOpen)}>
                            Riepilogo Mese {isAccordionOpen ? '▲' : '▼'}
                        </button>
                        <div className={`accordion-content ${isAccordionOpen ? 'open' : ''}`}>
                            {monthlyStats && (
                                <table className="summary-table">
                                    <thead>
                                        <tr>
                                            <th>Personale</th>
                                            <th>Ore Ordinarie</th>
                                            <th>Straordinario</th>
                                            <th>Permesso</th>
                                            <th>Ferie</th>
                                            <th>Malattia</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* 🆕 filteredStaffData invece di staffData: rispetta la tab aperta (Turnazione/BackOffice) */}
                                        {filteredStaffData.map(person => (
                                            monthlyStats[person.id] && (
                                                <tr key={person.name} style={{backgroundColor: 'white'}}>
                                                    <td style={{backgroundColor: person.color}}>{person.name}</td>
                                                    <td>{formatMinutesToHM(monthlyStats[person.id].OrdinaryMinutes)}</td>
                                                    <td className="summary-overtime">{formatMinutesToHM(monthlyStats[person.id].OvertimeMinutes)}</td>
                                                    <td className="summary-leave">{formatMinutesToHM(monthlyStats[person.id].LeaveMinutes)}</td>
                                                    <td>{monthlyStats[person.id].Ferie > 0 ? `${monthlyStats[person.id].Ferie} gg` : '-'}</td>
                                                    <td>{monthlyStats[person.id].Malattia > 0 ? `${monthlyStats[person.id].Malattia} gg` : '-'}</td>
                                                </tr>
                                            )
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>

                <div id="schedule-container">
                    <div className="month-title">{moment([selectedYear, selectedMonth]).format('MMMM YYYY').toUpperCase()}</div>

                    {/* --- NUOVO: SISTEMA A TAB --- */}
                    <div className="tabs-nav" style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', gap: '10px' }}>
                        <button 
                            onClick={() => setActiveTab('rotation')} 
                            style={{
                                padding: '10px 20px',
                                border: 'none',
                                background: 'none',
                                fontSize: '1rem',
                                cursor: 'pointer',
                                color: activeTab === 'rotation' ? '#0d6efd' : '#6c757d',
                                borderBottom: activeTab === 'rotation' ? '3px solid #0d6efd' : '3px solid transparent',
                                fontWeight: activeTab === 'rotation' ? 'bold' : 'normal'
                            }}
                        >
                            Turnazione
                        </button>
                        <button 
                            onClick={() => setActiveTab('backoffice')} 
                            style={{
                                padding: '10px 20px',
                                border: 'none',
                                background: 'none',
                                fontSize: '1rem',
                                cursor: 'pointer',
                                color: activeTab === 'backoffice' ? '#0d6efd' : '#6c757d',
                                borderBottom: activeTab === 'backoffice' ? '3px solid #0d6efd' : '3px solid transparent',
                                fontWeight: activeTab === 'backoffice' ? 'bold' : 'normal'
                            }}
                        >
                            BackOffice
                        </button>
                    </div>

                    {/* --- PULSANTE APPLICA MODELLO --- */}
                    {canEditAll && (
                        <div style={{textAlign: 'center', margin: '15px 0'}}>
                            <button 
                                onClick={handleOpenTemplateModal} 
                                disabled={isGenerating}
                                className="save-button" 
                                style={{
                                    backgroundColor: activeTab === 'backoffice' ? '#7c3aed' : '#2563eb', 
                                    color: 'white', border:'none', padding:'12px 24px', borderRadius:'8px', cursor:'pointer', fontSize: '1rem', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: '8px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
                                }}
                            >
                                {isGenerating ? 'Caricamento...' : '🪄 Applica Modello (Ciclo)'}
                            </button>
                            <p style={{fontSize: '0.85rem', color: '#64748b', marginTop: '8px'}}>
                                Seleziona un modello salvato e srotolalo automaticamente sulle settimane di questo mese.
                            </p>
                        </div>
                    )}

                    {weeksInMonth.map((week, weekIndex) => (
                        <table key={weekIndex} id={`week-${week[0].format('YYYY-MM-DD')}`}>
                            <thead>
                                <tr>
                                    <th></th>
                                    {week.slice(0, 6).map((day) => (
                                        <th key={day.format('YYYY-MM-DD')} className="week-day-header day-header-clickable" onClick={() => handleHeaderClick(day.format('YYYY-MM-DD'))}>
                                            {day.month() === selectedMonth ? (<>{day.format('ddd').toUpperCase()}<br/>{day.format('DD/MM')}</>) : ''}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredStaffData.map(person => {
                                    const canChangeThisCell = canEditAll || (canEditSelf && userProfile.uid === person.id);
                                    
                                    return (
                                        <tr key={person.id}>
                                            <td className="person-name" style={{backgroundColor: person.color, color: getContrastColor(person.color)}}>{person.name.toUpperCase()}</td>
                                            {week.slice(0, 6).map((day) => {
                                                if (day.month() !== selectedMonth) return <td key={day.format('YYYY-MM-DD')}></td>;
                                                return <ShiftCell 
                                                    key={day.format('YYYY-MM-DD')} 
                                                    personData={person} 
                                                    day={day} 
                                                    schedule={scheduleData.fullSchedule}
                                                    canChangeShift={canChangeThisCell} 
                                                    pendingRequests={pendingRequests}
                                                    onCellClick={(shiftData) => setModal({ type: 'change-shift', data: { personId: person.id, personName: person.name, dayStr: day.format('YYYY-MM-DD'), shiftData: shiftData } })} 
                                                />;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ))}
                    {weeksInMonth.length === 0 && (
                        <div className="holiday-message-container" style={{backgroundColor: '#e6f7ff', color: '#0d6efd'}}>
                            Nessun turno trovato per {moment([selectedYear, selectedMonth]).format('MMMM YYYY')}.
                            <br/>
                            {canEditAll && "Clicca il pulsante verde 'Genera' per calcolare i turni."}
                        </div>
                    )}
                </div>
            </div>

            {modal.type === 'change-shift' && <ChangeShiftModal modalData={modal.data} onConfirm={handleShiftChange} onClose={closeModal} availableShifts={allShiftOptions}/>}
            {modal.type === 'custom-confirmation' && 
    <ConfirmationModal 
        title={modal.data.title} 
        onConfirm={modal.data.onConfirm} 
        onClose={closeModal}
    >
        <p>{modal.data.message}</p>
    </ConfirmationModal>
}
             {modal.type === 'close-day' && <ConfirmationModal title="Conferma Chiusura" onConfirm={() => handleDayManagement(true)} onClose={closeModal}><p>Impostare questo giorno come CHIUSO per tutto il personale?</p></ConfirmationModal>}
            {modal.type === 'reopen-day' && <ConfirmationModal title="Conferma Riapertura" onConfirm={() => handleDayManagement(false)} onClose={closeModal}><p>Vuoi riaprire questo giorno e ripristinare i turni originali?</p></ConfirmationModal>}
            {modal.type === 'saturday-type' && <ChoiceModal title="Come vuoi gestire il cambio del sabato?" onClose={closeModal} choices={[
                //{ label: 'Scambio di turno (con recupero)', action: () => handleSaturdayChange('swap'), className: 'confirm-button' },
                { label: 'Assegna come Straordinario', action: () => handleSaturdayChange('overtime'), className: 'cancel-button' },
                { label: 'Aggiungi turno semplice (Nessun recupero)', action: () => handleSaturdayChange('simple'), className: 'neutral-button' },
            ]}><p>Assegnando a <b>{modal.data.person}</b>.</p></ChoiceModal>}
            
            {modal.type === 'swap-or-modify' && (
                <ChoiceModal
                    title="Come vuoi applicare la modifica?"
                    onClose={closeModal}
                    choices={[
                        ...modal.data.candidates.map(candidateName => ({
                            label: `Scambia con ${candidateName}`, 
                            action: () => handleSwapOrModifyChoice('swap', { 
                                ...modal.data, 
                                targetSwapName: candidateName 
                            }), 
                            className: 'confirm-button'
                        })),
                        { 
                            label: 'Modifica Solo Questo (No Scambio)', 
                            action: () => handleSwapOrModifyChoice('modify', modal.data), 
                            className: 'neutral-button' 
                        }
                    ]}
                >
                    <p style={{textAlign: 'left', lineHeight: 1.4}}>
                        Stai cambiando il turno di <b>{modal.data.choiceData.person}</b> in <b>{modal.data.choiceData.newShiftName}</b>.
                        <br/><br/>
                        {modal.data.candidates.length === 1 ? (
                            <span>Anche <b>{modal.data.candidates[0]}</b> ha questo turno.</span>
                        ) : (
                            <span>Le seguenti persone hanno già questo turno: <b>{modal.data.candidates.join(', ')}</b>.</span>
                        )}
                        <br/><br/>
                        Vuoi effettuare uno scambio con una di loro (che prenderà il turno <b>{modal.data.originalShiftOfPerson}</b>) oppure modificare solo questo inserimento?
                    </p>
                </ChoiceModal>
            )}
            {/* 🎯 FIX: NUOVO MODALE APPLICA TEMPLATE */}
            {modal.type === 'apply-template' && (
                <div className="modal" onMouseDown={closeModal}>
                    <div className="modal-content" onMouseDown={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                        <h3 style={{ margin: '0 0 20px 0', color: '#1e293b' }}>Applica Modello di Turnazione</h3>
                        
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Quale modello vuoi usare?</label>
                            {availableTemplates.length === 0 ? (
                                <p style={{ color: '#ef4444', fontStyle: 'italic', margin: 0 }}>Nessun modello salvato per questa sezione. Creane uno nella pagina Regole!</p>
                            ) : (
                                <select 
                                    value={modal.data.templateId} 
                                    onChange={(e) => setModal({ ...modal, data: { ...modal.data, templateId: e.target.value } })}
                                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem', backgroundColor: 'white', cursor: 'pointer' }}
                                >
                                    <option value="">-- Seleziona un Modello --</option>
                                    {availableTemplates.map(t => (
                                        <option key={t.id} value={t.id}>{t.name} (Ciclo di {t.cycleWeeks} sett.)</option>
                                    ))}
                                </select>
                            )}
                        </div>

                        <div style={{ display: 'flex', gap: '15px', marginBottom: '20px' }}>
                            <div className="form-group" style={{ flex: 1 }}>
                                <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Dal giorno</label>
                                <input 
                                    type="date" 
                                    value={modal.data.startDate}
                                    onChange={(e) => setModal({ ...modal, data: { ...modal.data, startDate: e.target.value } })}
                                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }}
                                />
                            </div>
                            <div className="form-group" style={{ flex: 1 }}>
                                <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Al giorno</label>
                                <input 
                                    type="date" 
                                    value={modal.data.endDate}
                                    onChange={(e) => setModal({ ...modal, data: { ...modal.data, endDate: e.target.value } })}
                                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }}
                                />
                            </div>
                        </div>

                        {/* --- MENU A TENDINA MODALITÀ --- */}
                        <div className="form-group" style={{ marginBottom: '25px' }}>
                            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Modalità di inserimento</label>
                            <select 
                                value={modal.data.mode || 'overwrite'} // Valore di default
                                onChange={(e) => setModal({ ...modal, data: { ...modal.data, mode: e.target.value } })}
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem', backgroundColor: '#f8fafc', cursor: 'pointer' }}
                            >
                                <option value="overwrite">Sovrascrivi tutto (Sostituisce i turni esistenti)</option>
                                <option value="fill_empty">Riempi solo vuoti (Mantiene i turni già assegnati)</option>
                            </select>
                            
                            {/* Testo di aiuto dinamico per chiarire l'azione */}
                            <p style={{ fontSize: '0.85rem', color: '#64748b', marginTop: '8px', lineHeight: '1.4' }}>
                                {(!modal.data.mode || modal.data.mode === 'overwrite') 
                                    ? "⚠️ Attenzione: i turni esistenti verranno sostituiti dal nuovo modello. Le ferie e le malattie approvate rimarranno intatte."
                                    : "ℹ️ I turni già presenti nel calendario non verranno toccati. Il modello riempirà solo gli spazi vuoti."}
                            </p>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button onClick={closeModal} className="modal-button neutral-button">Annulla</button>
                            <button 
                                onClick={handleApplyTemplateConfirm} 
                                disabled={!modal.data.templateId || availableTemplates.length === 0}
                                className="modal-button confirm-button"
                                style={{ opacity: (!modal.data.templateId || availableTemplates.length === 0) ? 0.5 : 1 }}
                            >
                                Applica Turni
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {modal.type === 'export-pdf-options' && (
                <ChoiceModal
                    title="Opzioni Esportazione PDF"
                    onClose={closeModal}
                    choices={[
                        { label: 'Solo Turni', action: () => handlePdfExport({ view: 'shifts' }), className: 'neutral-button' },
                        { label: 'Turni + Prospetto', action: () => handlePdfExport({ view: 'all' }), className: 'confirm-button' },
                        { label: 'Solo Prospetto', action: () => handlePdfExport({ view: 'summary' }), className: 'neutral-button' },
                    ]}
                >
                    <p>Scegli cosa includere nel file PDF:</p>
                </ChoiceModal>
            )
            }
            
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default ShiftsPage;